/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
import React, { Component } from "react";
import LayoutOperation from "../../components/layout_operation";
import {
  Table,
  Input,
  Select,
  DatePicker,
  Modal,
  Tooltip,
  Form,
  Menu,
  Dropdown,
  Checkbox,
  Spin,
} from "antd";
// import { css } from "emotion";
import { connect } from "react-redux";
import AssignJob from "../../ui/map/assign_job";
import Cookies from "js-cookie";
import { changeLang } from "../../actions/langAction";
import Api from "../../services/ServiceApi";
import moment from "moment";
import { Link } from "react-router-dom";
import ModalSuccess from "../../components/Modal_Success";
import ModalGiveStarScore from "../../components/Modal_GiveStarScore/Modal_GiveStarScore";
import XLSX from "xlsx";
// import { VList } from "virtuallist-antd";

function isEmpty(obj) {
  for (var prop in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, prop)) {
      return false;
    }
  }

  return JSON.stringify(obj) === JSON.stringify({});
}


let filteredData = [];
let hasFilteredValue = "";
const { Option } = Select;
const { RangePicker } = DatePicker;
const dateDiff = (item) => {
  var setDisplay = "";
  const startDate = moment(new Date());
  const timeEnd = moment(item);
  const diff = timeEnd.diff(startDate);
  const diffDuration = moment.duration(diff);

  setDisplay = (
    <span
      style={diffDuration.days() < 1 ? { color: "red" } : { color: "#747474" }}
    >
      {diffDuration.days() +
        " D " +
        diffDuration.hours() +
        " H " +
        diffDuration.minutes() +
        " M "}
    </span>
  );

  return setDisplay;
};

class MaxiOperationMA extends Component {
  formRef = React.createRef();
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      title: "MA List",
      Urgent_total: 0,
      High_total: 0,
      Normal_total: 0,
      Low_total: 0,
      all_emp: 0,
      emp_working: 0,
      emp_ab: 0,
      em_total: 0,
      em_available: 0,
      all_teamtotal: 0,
      team_available_total: 0,
      sum_alljob: 0,
      sum_onprocess: 0,
      sum_no_assing: 0,
      sum_wait_assign: 0,
      sum_approve: 0,
      data_assing: [],
      job_category: [],
      sc_status: [],
      priority: [
        { value: 3, text: "High" },
        { value: 2, text: "Normal" },
        { value: 1, text: "Low" },
        { value: null, text: "All Priority" },
      ],
      options: [
        { value: " and job_no = ", text: "Job ID", type: "str" },
        {
          value: " and job_area_code like ",
          text: "Area Code",
          type: "str",
        },
        {
          value: " and location_name like ",
          text: "Location",
          type: "str",
        },
        {
          value: " and asset_type_name ",
          text: "Asset type",
          type: "str",
        },
        { value: " and emp_inform_id ", text: "Inform Date", type: "date" },
      ],
      current_option: 1,
      data: [],
      data_no_assing: [],
      data_on_process: [],
      statustab: 1,
      modal_data: [],
      setDataAssign: [],
      ma_skill: [],
      ma_team: [],
      columns_allJob: [
        {
          title: "Job ID",
          dataIndex: "",
          key: "",
          width: 110,
          render: (item ) => (
            <Link
              onClick={() =>
                this.setCookies(
                  item.job_id,
                  item.job_progress_id,
                  item.job_type_id,
                  item.ma_type 
                )
              }
              to="/full_detail_job"
              className="c-blue text-underline"
            >
              {item.job_no}
            </Link>
          ),
          sorter: (a, b) => b.job_id - a.job_id,
        },
        {
          title: "Job Category",
          dataIndex: "job_category_name",
          key: "job_category_name",
          width: 120,
          sorter: (a, b) =>
            a.job_category_name.localeCompare(b.job_category_name),
        },
        {
          title: "Asset Code",
          key: "asset_code",
          ellipsis: {
            showTitle: false,
          },
          width: 120,
          render: (item) => (
            <Tooltip
              placement="topLeft"
              title={!item.asset_code ? "-" : item.asset_code}
            >
              {!item.asset_code ? "-" : item.asset_code}
            </Tooltip>
          ),
          sorter: (a, b) =>
            (a.asset_code ? a.asset_code.length : " ") -
            (b.asset_code ? b.asset_code.length : " "),
        },
        {
          title: "Asset Name",
          key: "asset_name",
          width: 130,
          render: (item) => {
            return (
              <Tooltip
                placement="topLeft"
                title={!item.asset_name ? "-" : item.asset_name}
              >
                {" "}
                {!item.asset_name ? "-" : item.asset_name}{" "}
              </Tooltip>
            );
          },
          sorter: (a, b) =>
            (a.asset_name ? a.asset_name.length : "-") -
            (b.asset_name ? b.asset_name.length : "-"),
          ellipsis: {
            showTitle: false,
          },
        },
        {
          title: "ถนน|แขวง|จังหวัด",
          key: "asset_loc",
          width: 130,
          render: (item) => {
            return (
              <Tooltip
                placement="topLeft"
                title={!item.asset_loc ? "-" : item.asset_loc}
              >
                {" "}
                {!item.asset_loc ? "-" : item.asset_loc}{" "}
              </Tooltip>
            );
          },
          sorter: (a, b) =>
            (a.asset_loc ? a.asset_loc.length : "-") -
            (b.asset_loc ? b.asset_loc.length : "-"),
          ellipsis: {
            showTitle: false,
          },
        },
        {
          title: "Package",
          key: "package_name",
          width: 130,
          render: (item) => {
            return (
              <Tooltip
                placement="topLeft"
                title={!item.package_name ? "-" : item.package_name}
              >
                {" "}
                {!item.package_name ? "-" : item.package_name}{" "}
              </Tooltip>
            );
          },
          sorter: (a, b) =>
            (a.package_name ? a.package_name.length : "-") -
            (b.package_name ? b.package_name.length : "-"),
          ellipsis: {
            showTitle: false,
          },
        },
        {
          title: "Inform Date",
          key: "emp_inform_date",
          width: 130,
          render: (item) => {
            {
              return !item.emp_inform_date
                ? "-"
                : moment(item.emp_inform_date).format("DD/MM/YYYY HH:mm");
            }
          },
          sorter: (a, b) => a.emp_inform_date.localeCompare(b.emp_inform_date),
        },
        {
          title: "Assign date",
          key: "plan_start_date",
          width: 150,
          render: (item) => {
            {
              return !item.plan_start_date
                ? "-"
                : moment(item.plan_start_date).format("DD/MM/YYYY HH:mm");
            }
          },
          sorter: (a, b) => a.plan_start_date.localeCompare(b.plan_start_date),
        },
        {
          title: "To date",
          key: "plan_end_Date",
          width: 150,
          render: (item) => {
            {
              return item.plan_end_date === null
                ? "-"
                : moment(item.plan_end_date).format("DD/MM/YYYY HH:mm");
            }
          },
          // sorter: () => null,
          sorter: (a, b) => a.plan_end_Date.localeCompare(b.plan_end_Date),
        },
        {
          title: "Inform Detail",
          key: "inform_detail",
          align: "center",
          width: 150,
          ellipsis: {
            showTitle: false,
          },
          render: (item) => (
            <Tooltip
              placement="topLeft"
              title={!item.inform_detail ? "-" : item.inform_detail}
            >
              {!item.inform_detail ? "-" : item.inform_detail}
            </Tooltip>
          ),
          sorter: (a, b) =>
            (a.inform_detail ? a.inform_detail.length : " ") -
            (b.inform_detail ? b.inform_detail.length : " "),
        },
        {
          title: "Inform Remark",
          key: "inform_remark",
          width: 150,
          ellipsis: {
            showTitle: false,
          },
          render: (item) => {
            return (
              <Tooltip
                placement="topLeft"
                title={!item.inform_remark ? "-" : item.inform_remark}
              >
                {" "}
                {!item.inform_remark ? "-" : item.inform_remark}{" "}
              </Tooltip>
            );
          },
          sorter: (a, b) =>
            (a.inform_remark ? a.inform_remark.length : " ") -
            (b.inform_remark ? b.inform_remark.length : " "),
        },
        {
          title: "Asset Type",
          width: 100,
          ellipsis: {
            showTitle: false,
          },
          render: (item) => {
            return (
              <Tooltip
                placement="topLeft"
                title={!item.asset_type ? "-" : item.asset_type}
              >
                {" "}
                {!item.asset_type ? "-" : item.asset_type}{" "}
              </Tooltip>
            );
          },
        },
        {
          title: "Priority",
          dataIndex: "priority_level",
          key: "priority_level",
          width: 70,
          render: (item) => (
            <div>
              {item == "1" ? (
                <span style={{ color: "#618817" }}>Low</span>
              ) : null}
              {item == "2" ? (
                <span style={{ color: "#E8CD00" }}>Normal</span>
              ) : null}
              {item == "3" ? (
                <span style={{ color: "#E09307" }}>High</span>
              ) : null}
            </div>
          ),
          sorter: (a, b) => a.priority_level - b.priority_level,
        },
        {
          title: "Status",
          dataIndex: "",
          key: "",
          width: 200,
          align: "center",
          render: (item) => (
            <div>
              {item.job_status === 2 ||
                item.job_status === 3 ||
                item.job_status === 31 ? (
                item.job_status === 2 ? (
                  <span className="badge badge-pill badge-light on-process font-thai-b font14">
                    <span className="dot-on-process mr-2"></span>
                    {item.job_status_name}
                  </span>
                ) : (
                  <span className="badge badge-pill badge-light on-process font-thai-b font14">
                    <span className="dot-on-process mr-2"></span>
                    {item.job_status_name}
                  </span>
                )
              ) : (
                <span className="badge badge-pill badge-light font-thai-b font14">
                  {item.job_status === 0 ? item.job_status_name : null}
                  {item.job_status === 1 ? item.job_status_name : null}
                  {item.job_status === 33 ? item.job_status_name : null}
                  {item.job_status === 36 ? item.job_status_name : null}
                  {item.job_status === 18 ? item.job_status_name : null}
                  {item.job_status === 4 ? item.job_status_name : null}
                  {item.job_status === 5 ? item.job_status_name : null}
                  {item.job_status === 7 ? item.job_status_name : null}
                  {item.job_status === 999 ? item.job_status_name : null}
                </span>
              )}
            </div>
          ),
          sorter: (a, b) => a.job_status - b.job_status,
        },
        {
          title: "ผู้สร้าง",
          width: 150,
          render: (item) => (!item.create_by ? "-" : item.create_by),
          key: "create_by",
          sorter: (a, b) =>
            (a.create_by ? a.create_by.length : " ") -
            (b.create_by ? b.create_by.length : " "),
        },
        {
          title: "ผู้รับ",
          width: 150,
          ellipsis: {
            showTitle: false,
          },
          key: "emp_owner_job",
          render: (item) => {
            return (
              <Tooltip
                placement="topLeft"
                title={!item.emp_owner_job ? "-" : item.emp_owner_job}
              >
                {" "}
                {!item.emp_owner_job ? "-" : item.emp_owner_job}{" "}
              </Tooltip>
            );
          },

          sorter: (a, b) =>
            (a.emp_owner_job ? a.emp_owner_job.length : " ") -
            (b.emp_owner_job ? b.emp_owner_job.length : " "),
        },
        {
          title: "SLA คงเหลือ",
          width: 150,
          render: (item) =>
            item.end_sla_date === null ? "-" : dateDiff(item.end_sla_date),
          key: "end_sla_date",
          align: "center",
          sorter: (a, b) =>
            (a.end_sla_date ? a.end_sla_date.length : " ") -
            (b.end_sla_date ? b.end_sla_date.length : " "),
        },
        {
          title: "Last Reason",
          width: 150,
          render: (item) => (item.remark === null ? "-" : item.remark),
          key: "remark",
          align: "center",
          sorter: (a, b) =>
            (a.remark ? a.remark.length : " ") -
            (b.remark ? b.remark.length : " "),
        },
        {
          title: "Action",
          dataIndex: "",
          width: 100,
          key: "",
          align: "center",
          render: (item) => (
            <>
              {item.job_status === 1 ||
                item.job_status === 33 ||
                item.job_status === 36 ||
                item.job_status === 7 ||
                item.job_status === 29 ||
                item.job_status === 18 ||
                item.job_status === 2 ? (
                <>
                  <a
                    className={
                      item.job_status === 1 ||
                        item.job_status === 33 ||
                        item.job_status === 36 ||
                        item.job_status === 7 ||
                        item.job_status === 29 ||
                        item.job_status === 18
                        ? "ant-dropdown-link c-blue mr-3 divshow"
                        : "divhide"
                    }
                    onClick={() => this.onModal(true, item, "assign")}
                  >
                    <img src={Api.absoluteUrl("/icon/icon_assign.svg")} />
                  </a>

                  <Dropdown
                    overlay={
                      <Menu>
                        {item.job_status !== 2 ? (
                          <Menu.Item key="0">
                            <a
                              onClick={() =>
                                this.setState({
                                  visible_cancel: true,
                                  data_cancel: item,
                                })
                              }
                            >
                              <img
                                src={Api.absoluteUrl("/icon/icon_cancel.svg")}
                                className="mr-2"
                              />
                              Cancel
                            </a>
                          </Menu.Item>
                        ) : null}
                        {item.job_status !== 2 ? (
                          <Menu.Item key="1">
                            <a
                              // className="c-red"
                              onClick={() => this.btneditjob(item)}
                            >
                              <img
                                src={Api.absoluteUrl("/icon/icon_edit.svg")}
                                className="mr-2"
                              />
                              Edit
                            </a>
                          </Menu.Item>
                        ) : null}
                        {item.job_status === 2 ? (
                          <Menu.Item key="2">
                            <a onClick={() => this.onHandlereassign(item)}>
                              <img
                                src={Api.absoluteUrl("/icon/icon_edit.svg")}
                                className="mr-2"
                              />
                              Re-Assign
                            </a>
                          </Menu.Item>
                        ) : null}
                      </Menu>
                    }
                    trigger={["click"]}
                  >
                    <a
                      className="ant-dropdown-link c-blue"
                      // onClick={(e) => e.preventDefault()}
                      style={
                        item.job_status === 2 ? { marginLeft: "53px" } : null
                      }
                    >
                      <img src={Api.absoluteUrl("/icon/menu_list.svg")} />
                    </a>
                  </Dropdown>
                </>
              ) : (
                <img
                  src={Api.absoluteUrl("/icon/icon_assign.svg")}
                  style={{ opacity: "0%" }}
                />
              )}
            </>
          ),
        },
      ],
      columns_on_process: [
        {
          title: (
            <Checkbox onChange={() => this.CheckboxAssign("all")}></Checkbox>
          ),
          dataIndex: "",
          width: 40,
          key: "",
          render: (item) => (
            <>
              {item.job_status === 1 ||
                item.job_status === 33 ||
                item.job_status === 36 ||
                item.job_status === 7 ||
                item.job_status === 29 ||
                item.job_status === 18 ||
                item.job_status === 2 ? (
                <Checkbox
                  onChange={() => this.CheckboxAssign(item)}
                  checked={item["status_checkbox"]}
                ></Checkbox>
              ) : null}
            </>
          ),

          // sorter: () => null,
        },
        {
          title: "Job ID",
          dataIndex: "",
          key: "",
          width: 120,
          render: (item) => (
            <Link
              onClick={() =>
                this.setCookies(
                  item.job_id,
                  item.job_progress_id,
                  item.job_type_id,
                  item.ma_type
                )
              }
              to="/full_detail_job"
              className="c-blue text-underline"
            >
              {item.job_no}
            </Link>
          ),
          sorter: (a, b) => b.job_id - a.job_id,
        },
        {
          title: "Job Category",
          dataIndex: "job_category_name",
          key: "job_category_name",
          // defaultSortOrder: "descend",
          width: 120,
          // sorter: () => null,
          sorter: (a, b) =>
            a.job_category_name.localeCompare(b.job_category_name),
        },
        {
          title: "Asset Code",
          key: "asset_code",
          ellipsis: {
            showTitle: false,
          },
          width: 120,
          render: (item) => (
            <Tooltip
              placement="topLeft"
              title={!item.asset_code ? "-" : item.asset_code}
            >
              {!item.asset_code ? "-" : item.asset_code}
            </Tooltip>
          ),
          sorter: (a, b) =>
            (a.asset_code ? a.asset_code.length : " ") -
            (b.asset_code ? b.asset_code.length : " "),
        },
        {
          title: "Asset Name",
          key: "asset_name",
          width: 130,
          render: (item) => {
            return (
              <Tooltip
                placement="topLeft"
                title={!item.asset_name ? "-" : item.asset_name}
              >
                {" "}
                {!item.asset_name ? "-" : item.asset_name}{" "}
              </Tooltip>
            );
          },
          sorter: (a, b) =>
            (a.asset_name ? a.asset_name.length : "-") -
            (b.asset_name ? b.asset_name.length : "-"),
          ellipsis: {
            showTitle: false,
          },
        },
        {
          title: "ถนน|แขวง|จังหวัด",
          key: "asset_loc",
          width: 130,
          render: (item) => {
            return (
              <Tooltip
                placement="topLeft"
                title={!item.asset_loc ? "-" : item.asset_loc}
              >
                {" "}
                {!item.asset_loc ? "-" : item.asset_loc}{" "}
              </Tooltip>
            );
          },
          sorter: (a, b) =>
            (a.asset_loc ? a.asset_loc.length : "-") -
            (b.asset_loc ? b.asset_loc.length : "-"),
          ellipsis: {
            showTitle: false,
          },
        },
        {
          title: "Package",
          key: "package_name",
          width: 130,
          render: (item) => {
            return (
              <Tooltip
                placement="topLeft"
                title={!item.package_name ? "-" : item.package_name}
              >
                {" "}
                {!item.package_name ? "-" : item.package_name}{" "}
              </Tooltip>
            );
          },
          sorter: (a, b) =>
            (a.package_name ? a.package_name.length : "-") -
            (b.package_name ? b.package_name.length : "-"),
          ellipsis: {
            showTitle: false,
          },
        },
        {
          title: "Inform Date",
          key: "emp_inform_date",
          width: 130,
          render: (item) => {
            {
              return !item.emp_inform_date
                ? "-"
                : moment(item.emp_inform_date).format("DD/MM/YYYY HH:mm");
            }
          },
          // sorter: () => null,
          sorter: (a, b) => a.emp_inform_date.localeCompare(b.emp_inform_date),
        },
        {
          title: "Assign date",
          key: "plan_start_date",
          width: 150,
          render: (item) => {
            {
              return !item.plan_start_date
                ? "-"
                : moment(item.plan_start_date).format("DD/MM/YYYY HH:mm");
            }
          },
          // sorter: () => null,
          sorter: (a, b) => a.plan_start_date.localeCompare(b.plan_start_date),
        },
        {
          title: "To date",
          key: "plan_end_Date",
          width: 150,
          render: (item) => {
            {
              return item.plan_end_date === null
                ? "-"
                : moment(item.plan_end_date).format("DD/MM/YYYY HH:mm");
            }
          },
          // sorter: () => null,
          sorter: (a, b) => a.plan_end_Date.localeCompare(b.plan_end_Date),
        },
        {
          title: "Inform Detail",
          key: "inform_detail",
          align: "center",
          width: 150,
          ellipsis: {
            showTitle: false,
          },
          render: (item) => (
            <Tooltip
              placement="topLeft"
              title={!item.inform_detail ? "-" : item.inform_detail}
            >
              {!item.inform_detail ? "-" : item.inform_detail}
            </Tooltip>
          ),
          sorter: (a, b) =>
            (a.inform_detail ? a.inform_detail.length : " ") -
            (b.inform_detail ? b.inform_detail.length : " "),
        },
        {
          title: "Inform Remark",
          key: "inform_remark",
          // sorter: (a, b) => a.inform_detail - b.inform_detail,
          width: 150,
          ellipsis: {
            showTitle: false,
          },
          render: (item) => {
            return (
              <Tooltip
                placement="topLeft"
                title={!item.inform_remark ? "-" : item.inform_remark}
              >
                {" "}
                {!item.inform_remark ? "-" : item.inform_remark}{" "}
              </Tooltip>
            );
          },
          sorter: (a, b) =>
            (a.inform_remark ? a.inform_remark.length : " ") -
            (b.inform_remark ? b.inform_remark.length : " "),
        },
        {
          title: "Asset Type",
          width: 100,
          ellipsis: {
            showTitle: false,
          },
          render: (item) => {
            return (
              <Tooltip
                placement="topLeft"
                title={!item.asset_type ? "-" : item.asset_type}
              >
                {" "}
                {!item.asset_type ? "-" : item.asset_type}{" "}
              </Tooltip>
            );
          },
        },
        {
          title: "Priority",
          dataIndex: "priority_level",
          key: "priority_level",
          width: 70,
          render: (item) => (
            <div>
              {item == "1" ? (
                <span style={{ color: "#618817" }}>Low</span>
              ) : null}
              {item == "2" ? (
                <span style={{ color: "#E8CD00" }}>Normal</span>
              ) : null}
              {item == "3" ? (
                <span style={{ color: "#E09307" }}>High</span>
              ) : null}
            </div>
          ),
          sorter: (a, b) => a.priority_level - b.priority_level,
        },
        {
          title: "Status",
          dataIndex: "",
          key: "",
          width: 200,
          align: "center",
          // sorter: (a, b) => a.job_status - b.job_status,
          render: (item) => (
            <div>
              {item.job_status === 2 ||
                item.job_status === 3 ||
                item.job_status === 31 ? (
                item.job_status === 2 ? (
                  <span className="badge badge-pill badge-light on-process font-thai-b font14">
                    <span className="dot-on-process mr-2"></span>
                    {item.job_status_name}
                  </span>
                ) : (
                  <span className="badge badge-pill badge-light on-process font-thai-b font14">
                    <span className="dot-on-process mr-2"></span>
                    {item.job_status_name}
                  </span>
                )
              ) : (
                <span className="badge badge-pill badge-light font-thai-b font14">
                  {item.job_status === 0 ? item.job_status_name : null}
                  {item.job_status === 1 ? item.job_status_name : null}
                  {item.job_status === 33 ? item.job_status_name : null}
                  {item.job_status === 36 ? item.job_status_name : null}
                  {item.job_status === 18 ? item.job_status_name : null}
                  {item.job_status === 4 ? item.job_status_name : null}
                  {item.job_status === 5 ? item.job_status_name : null}
                  {item.job_status === 7 ? item.job_status_name : null}
                  {item.job_status === 999 ? item.job_status_name : null}
                </span>
              )}
            </div>
          ),
          sorter: (a, b) => a.job_status - b.job_status,
        },
        {
          title: "ผู้สร้าง",
          width: 150,
          render: (item) => (!item.create_by ? "-" : item.create_by),
          key: "create_by",
          sorter: (a, b) =>
            (a.create_by ? a.create_by.length : " ") -
            (b.create_by ? b.create_by.length : " "),
        },
        {
          title: "ผู้รับ",
          width: 150,
          ellipsis: {
            showTitle: false,
          },
          key: "emp_owner_job",
          render: (item) => {
            return (
              <Tooltip
                placement="topLeft"
                title={!item.emp_owner_job ? "-" : item.emp_owner_job}
              >
                {" "}
                {!item.emp_owner_job ? "-" : item.emp_owner_job}{" "}
              </Tooltip>
            );
          },

          sorter: (a, b) =>
            (a.emp_owner_job ? a.emp_owner_job.length : " ") -
            (b.emp_owner_job ? b.emp_owner_job.length : " "),
        },
        {
          title: "SLA คงเหลือ",
          width: 150,
          render: (item) =>
            item.end_sla_date === null ? "-" : dateDiff(item.end_sla_date),
          key: "end_sla_date",
          align: "center",
          sorter: (a, b) =>
            (a.end_sla_date ? a.end_sla_date.length : " ") -
            (b.end_sla_date ? b.end_sla_date.length : " "),
        },
        {
          title: "Last Reason",
          width: 150,
          render: (item) => (item.remark === null ? "-" : item.remark),
          key: "remark",
          align: "center",
          sorter: (a, b) =>
            (a.remark ? a.remark.length : " ") -
            (b.remark ? b.remark.length : " "),
        },
        {
          title: "Action",
          dataIndex: "",
          key: "",
          width: 100,
          align: "center",
          render: (item) => (
            <>
              {item.job_status === 1 ||
                item.job_status === 33 ||
                item.job_status === 36 ||
                item.job_status === 7 ||
                item.job_status === 29 ||
                item.job_status === 18 ||
                item.job_status === 2 ? (
                <>
                  <a
                    className={"ant-dropdown-link c-blue divshow"
                    }
                    onClick={() => this.onModal(true, item, "Wait Ack Job")}
                  >
                    <img src={Api.absoluteUrl("/icon/icon_assign.svg")} />
                  </a>

                  <Dropdown
                    overlay={
                      <Menu>
                        {item.job_status !== 2 ? (
                          <Menu.Item key="0">
                            <a
                              onClick={() =>
                                this.setState({
                                  visible_cancel: true,
                                  data_cancel: item,
                                })
                              }
                            >
                              <img
                                src={Api.absoluteUrl("/icon/icon_cancel.svg")}
                                className="mr-2"
                              />
                              Cancel
                            </a>
                          </Menu.Item>
                        ) : null}
                        {item.job_status !== 2 ? (
                          <Menu.Item key="1">
                            <a
                              // className="c-red"
                              onClick={() => this.btneditjob(item)}
                            >
                              <img
                                src={Api.absoluteUrl("/icon/icon_edit.svg")}
                                className="mr-2"
                              />
                              Edit
                            </a>
                          </Menu.Item>
                        ) : null}
                        {item.job_status === 2 ? (
                          <Menu.Item key="2">
                            <a
                              // className="c-red"
                              // onClick={() => this.btneditjob(item)}
                              onClick={() => this.onHandlereassign(item)}
                            >
                              <img
                                src={Api.absoluteUrl("/icon/icon_edit.svg")}
                                className="mr-2"
                              />
                              Re-Assign
                            </a>
                          </Menu.Item>
                        ) : null}
                      </Menu>
                    }
                    trigger={["click"]}
                  >
                    <a
                      className="ant-dropdown-link c-blue"
                      // onClick={(e) => e.preventDefault()}
                      style={
                        item.job_status === 2 ? { marginLeft: "3px" } : null
                      }
                    >
                      <img src={Api.absoluteUrl("/icon/menu_list.svg")} />
                    </a>
                  </Dropdown>
                </>
              ) : (
                <img
                  src={Api.absoluteUrl("/icon/icon_assign.svg")}
                  style={{ opacity: "0%" }}
                />
              )}
            </>
          ),
        },
      ],
      columns_no_assign: [
        {
          title: (
            <Checkbox onChange={() => this.CheckboxAssign("all")}></Checkbox>
          ),
          dataIndex: "",
          width: 40,
          key: "",
          render: (item) => (
            <Checkbox
              onChange={() => this.CheckboxAssign(item)}
              checked={item["status_checkbox"]}
            ></Checkbox>
          ),
          // sorter: () => null,
        },
        {
          title: "Job ID",
          dataIndex: "",
          key: "",
          width: 110,
          render: (item) => (
            <Link
              onClick={() =>
                this.setCookies(
                  item.job_id,
                  item.job_progress_id,
                  item.job_type_id,
                  item.ma_type
                )
              }
              to="/full_detail_job"
              className="c-blue text-underline"
            >
              {item.job_no}
            </Link>
          ),
          sorter: (a, b) => b.job_id - a.job_id,
        },
        {
          title: "Job Category",
          dataIndex: "job_category_name",
          key: "job_category_name",
          // defaultSortOrder: "descend",
          width: 120,
          // sorter: () => null,
          sorter: (a, b) =>
            a.job_category_name.localeCompare(b.job_category_name),
        },
        {
          title: "Asset Code",
          key: "asset_code",
          ellipsis: {
            showTitle: false,
          },
          width: 120,
          render: (item) => (
            <Tooltip
              placement="topLeft"
              title={!item.asset_code ? "-" : item.asset_code}
            >
              {!item.asset_code ? "-" : item.asset_code}
            </Tooltip>
          ),
          sorter: (a, b) =>
            (a.asset_code ? a.asset_code.length : " ") -
            (b.asset_code ? b.asset_code.length : " "),
        },
        {
          title: "Asset Name",
          key: "asset_name",
          width: 130,
          render: (item) => {
            return (
              <Tooltip
                placement="topLeft"
                title={!item.asset_name ? "-" : item.asset_name}
              >
                {" "}
                {!item.asset_name ? "-" : item.asset_name}{" "}
              </Tooltip>
            );
          },
          sorter: (a, b) =>
            (a.asset_name ? a.asset_name.length : "-") -
            (b.asset_name ? b.asset_name.length : "-"),
          ellipsis: {
            showTitle: false,
          },
        },
        {
          title: "ถนน|แขวง|จังหวัด",
          key: "asset_loc",
          width: 130,
          render: (item) => {
            return (
              <Tooltip
                placement="topLeft"
                title={!item.asset_loc ? "-" : item.asset_loc}
              >
                {" "}
                {!item.asset_loc ? "-" : item.asset_loc}{" "}
              </Tooltip>
            );
          },
          sorter: (a, b) =>
            (a.asset_loc ? a.asset_loc.length : "-") -
            (b.asset_loc ? b.asset_loc.length : "-"),
          ellipsis: {
            showTitle: false,
          },
        },
        {
          title: "Package",
          key: "package_name",
          width: 130,
          render: (item) => {
            return (
              <Tooltip
                placement="topLeft"
                title={!item.package_name ? "-" : item.package_name}
              >
                {" "}
                {!item.package_name ? "-" : item.package_name}{" "}
              </Tooltip>
            );
          },
          sorter: (a, b) =>
            (a.package_name ? a.package_name.length : "-") -
            (b.package_name ? b.package_name.length : "-"),
          ellipsis: {
            showTitle: false,
          },
        },
        {
          title: "Inform Date",
          key: "emp_inform_date",
          width: 130,
          render: (item) => {
            {
              return !item.emp_inform_date
                ? "-"
                : moment(item.emp_inform_date).format("DD/MM/YYYY HH:mm");
            }
          },
          // sorter: () => null,
          sorter: (a, b) => a.emp_inform_date.localeCompare(b.emp_inform_date),
        },
        {
          title: "Assign date",
          key: "plan_start_date",
          width: 150,
          render: (item) => {
            {
              return !item.plan_start_date
                ? "-"
                : moment(item.plan_start_date).format("DD/MM/YYYY HH:mm");
            }
          },
          // sorter: () => null,
          sorter: (a, b) => a.plan_start_date.localeCompare(b.plan_start_date),
        },
        {
          title: "To date",
          key: "plan_end_Date",
          width: 150,
          render: (item) => {
            {
              return item.plan_end_date === null
                ? "-"
                : moment(item.plan_end_date).format("DD/MM/YYYY HH:mm");
            }
          },
          // sorter: () => null,
          sorter: (a, b) => a.plan_end_Date.localeCompare(b.plan_end_Date),
        },
        {
          title: "Inform Detail",
          key: "inform_detail",
          align: "center",
          width: 150,
          ellipsis: {
            showTitle: false,
          },
          render: (item) => (
            <Tooltip
              placement="topLeft"
              title={!item.inform_detail ? "-" : item.inform_detail}
            >
              {!item.inform_detail ? "-" : item.inform_detail}
            </Tooltip>
          ),
          sorter: (a, b) =>
            (a.inform_detail ? a.inform_detail.length : " ") -
            (b.inform_detail ? b.inform_detail.length : " "),
        },
        {
          title: "Inform Remark",
          key: "inform_remark",
          // sorter: (a, b) => a.inform_detail - b.inform_detail,
          width: 150,
          ellipsis: {
            showTitle: false,
          },
          render: (item) => {
            return (
              <Tooltip
                placement="topLeft"
                title={!item.inform_remark ? "-" : item.inform_remark}
              >
                {" "}
                {!item.inform_remark ? "-" : item.inform_remark}{" "}
              </Tooltip>
            );
          },
          sorter: (a, b) =>
            (a.inform_remark ? a.inform_remark.length : " ") -
            (b.inform_remark ? b.inform_remark.length : " "),
        },
        {
          title: "Asset Type",
          width: 100,
          ellipsis: {
            showTitle: false,
          },
          render: (item) => {
            return (
              <Tooltip
                placement="topLeft"
                title={!item.asset_type ? "-" : item.asset_type}
              >
                {" "}
                {!item.asset_type ? "-" : item.asset_type}{" "}
              </Tooltip>
            );
          },
          key: "asset_type",
          sorter: (a, b) =>
            (a.asset_type ? a.asset_type.length : " ") -
            (b.asset_type ? b.asset_type.length : " "),
        },
        {
          title: "Priority",
          dataIndex: "priority_level",
          key: "priority_level",
          width: 70,
          render: (item) => (
            <div>
              {item == "1" ? (
                <span style={{ color: "#618817" }}>Low</span>
              ) : null}
              {item == "2" ? (
                <span style={{ color: "#E8CD00" }}>Normal</span>
              ) : null}
              {item == "3" ? (
                <span style={{ color: "#E09307" }}>High</span>
              ) : null}
            </div>
          ),
          sorter: (a, b) => a.priority_level - b.priority_level,
        },
        {
          title: "Status",
          dataIndex: "",
          key: "",
          width: 200,
          align: "center",
          // sorter: (a, b) => a.job_status - b.job_status,
          render: (item) => (
            <div>
              {item.job_status === 2 ||
                item.job_status === 3 ||
                item.job_status === 31 ? (
                item.job_status === 2 ? (
                  <span className="badge badge-pill badge-light on-process font-thai-b font14">
                    <span className="dot-on-process mr-2"></span>
                    {item.job_status_name}
                  </span>
                ) : (
                  <span className="badge badge-pill badge-light on-process font-thai-b font14">
                    <span className="dot-on-process mr-2"></span>
                    {item.job_status_name}
                  </span>
                )
              ) : (
                <span className="badge badge-pill badge-light font-thai-b font14">
                  {item.job_status === 0 ? item.job_status_name : null}
                  {item.job_status === 1 ? item.job_status_name : null}
                  {item.job_status === 33 ? item.job_status_name : null}
                  {item.job_status === 36 ? item.job_status_name : null}
                  {item.job_status === 18 ? item.job_status_name : null}
                  {item.job_status === 4 ? item.job_status_name : null}
                  {item.job_status === 5 ? item.job_status_name : null}
                  {item.job_status === 7 ? item.job_status_name : null}
                  {item.job_status === 999 ? item.job_status_name : null}
                </span>
              )}
            </div>
          ),
          sorter: (a, b) => a.job_status - b.job_status,
        },
        {
          title: "ผู้สร้าง",
          width: 150,
          render: (item) => (!item.create_by ? "-" : item.create_by),
          key: "create_by",
          sorter: (a, b) =>
            (a.create_by ? a.create_by.length : " ") -
            (b.create_by ? b.create_by.length : " "),
        },
        {
          title: "ผู้รับ",
          width: 150,
          ellipsis: {
            showTitle: false,
          },
          key: "emp_owner_job",
          render: (item) => {
            return (
              <Tooltip
                placement="topLeft"
                title={!item.emp_owner_job ? "-" : item.emp_owner_job}
              >
                {" "}
                {!item.emp_owner_job ? "-" : item.emp_owner_job}{" "}
              </Tooltip>
            );
          },

          sorter: (a, b) =>
            (a.emp_owner_job ? a.emp_owner_job.length : " ") -
            (b.emp_owner_job ? b.emp_owner_job.length : " "),
        },
        {
          title: "SLA คงเหลือ",
          width: 150,
          render: (item) =>
            item.end_sla_date === null ? "-" : dateDiff(item.end_sla_date),
          key: "end_sla_date",
          align: "center",
          sorter: (a, b) =>
            (a.end_sla_date ? a.end_sla_date.length : " ") -
            (b.end_sla_date ? b.end_sla_date.length : " "),
        },
        {
          title: "Last Reason",
          width: 150,
          render: (item) => (item.remark === null ? "-" : item.remark),
          key: "remark",
          align: "center",
          sorter: (a, b) =>
            (a.remark ? a.remark.length : " ") -
            (b.remark ? b.remark.length : " "),
        },
        {
          title: "Action",
          dataIndex: "",
          width: 100,
          key: "",
          align: "center",
          render: (item) => (
            <>
              {
                item.job_status === 1 ||
                  item.job_status === 33 ||
                  item.job_status === 36 ||
                  item.job_status === 7 ||
                  item.job_status === 29 ||
                  item.job_status === 18 ||
                  item.job_status === 2 ? (
                  <>
                    <a
                      className={
                        item.job_status === 1 ||
                          item.job_status === 33 ||
                          item.job_status === 36 ||
                          item.job_status === 7 ||
                          item.job_status === 29 ||
                          item.job_status === 18
                          ? "ant-dropdown-link c-blue mr-3 divshow"
                          : "divhide"
                      }
                      onClick={() => this.onModal(true, item, "assign")}
                    >
                      <img src={Api.absoluteUrl("/icon/icon_assign.svg")} />
                    </a>

                    <Dropdown
                      overlay={
                        <Menu>
                          {item.job_status !== 2 ? (
                            <Menu.Item key="0">
                              <a
                                onClick={() =>
                                  this.setState({
                                    visible_cancel: true,
                                    data_cancel: item,
                                  })
                                }
                              >
                                <img
                                  src={Api.absoluteUrl("/icon/icon_cancel.svg")}
                                  className="mr-2"
                                />
                                Cancel
                              </a>
                            </Menu.Item>
                          ) : null}
                          {item.job_status !== 2 ? (
                            <Menu.Item key="1">
                              <a
                                // className="c-red"
                                onClick={() => this.btneditjob(item)}
                              >
                                <img
                                  src={Api.absoluteUrl("/icon/icon_edit.svg")}
                                  className="mr-2"
                                />
                                Edit
                              </a>
                            </Menu.Item>
                          ) : null}
                          {item.job_status === 2 ? (
                            <Menu.Item key="2">
                              <a
                                // className="c-red"
                                // onClick={() => this.btneditjob(item)}
                                onClick={() => this.onHandlereassign(item)}
                              >
                                <img
                                  src={Api.absoluteUrl("/icon/icon_edit.svg")}
                                  className="mr-2"
                                />
                                Re-Assign
                              </a>
                            </Menu.Item>
                          ) : null}
                        </Menu>
                      }
                      trigger={["click"]}
                    >
                      <a
                        className="ant-dropdown-link c-blue"
                        // onClick={(e) => e.preventDefault()}
                        style={
                          item.job_status === 2 ? { marginLeft: "53px" } : null
                        }
                      >
                        <img src={Api.absoluteUrl("/icon/menu_list.svg")} />
                      </a>
                    </Dropdown>
                  </>
                ) : (
                  <img
                    src={Api.absoluteUrl("/icon/icon_assign.svg")}
                    style={{ opacity: "0%" }}
                  />
                )

                // (
                //   <span style={{ textAlign: "center" }}>
                //     <a href="#" onClick={() => this.btneditjob(item)}>
                //       <img src={Api.absoluteUrl("/icon/edit.svg")} />
                //     </a>
                //   </span>
                // )
              }
            </>
          ),
        },
      ],
      columns_approve: [
        {
          title: "Job ID",
          width: 110,
          render: (item) => (
            <Link
              onClick={() => {
                this.setCookies(item.job_id, item.job_progress_id, item.ma_type);
              }}
              to="/full_detail_job"
              className="c-blue text-underline"
            >
              {item.job_no}
            </Link>
          ),
          sorter: (a, b) => b.job_id - a.job_id,
        },
        {
          title: "Job Category",
          dataIndex: "job_category_name",
          width: 120,
          sorter: (a, b) =>
            a.job_category_name.length - b.job_category_name.length,
        },
        {
          title: "Asset Code",
          key: "asset_code",
          ellipsis: {
            showTitle: false,
          },
          width: 120,
          render: (item) => (
            <Tooltip
              placement="topLeft"
              title={!item.asset_code ? "-" : item.asset_code}
            >
              {!item.asset_code ? "-" : item.asset_code}
            </Tooltip>
          ),
          sorter: (a, b) =>
            (a.asset_code ? a.asset_code.length : " ") -
            (b.asset_code ? b.asset_code.length : " "),
        },
        {
          title: "Asset Name",
          key: "asset_name",
          width: 130,
          ellipsis: {
            showTitle: false,
          },

          render: (item) => (
            <Tooltip
              placement="topLeft"
              title={!item.asset_name ? "-" : item.asset_name}
            >
              {!item.asset_name ? "-" : item.asset_name}
            </Tooltip>
          ),
          sorter: (a, b) => a.asset_name.length - b.asset_name.length,
        },
        {
          title: "ถนน|แขวง|จังหวัด",
          key: "asset_loc",
          width: 130,
          render: (item) => {
            return (
              <Tooltip
                placement="topLeft"
                title={!item.asset_loc ? "-" : item.asset_loc}
              >
                {" "}
                {!item.asset_loc ? "-" : item.asset_loc}{" "}
              </Tooltip>
            );
          },
          sorter: (a, b) =>
            (a.asset_loc ? a.asset_loc.length : "-") -
            (b.asset_loc ? b.asset_loc.length : "-"),
          ellipsis: {
            showTitle: false,
          },
        },
        {
          title: "Package",
          key: "package_name",
          width: 130,
          render: (item) => {
            return (
              <Tooltip
                placement="topLeft"
                title={!item.package_name ? "-" : item.package_name}
              >
                {" "}
                {!item.package_name ? "-" : item.package_name}{" "}
              </Tooltip>
            );
          },
          sorter: (a, b) =>
            (a.package_name ? a.package_name.length : "-") -
            (b.package_name ? b.package_name.length : "-"),
          ellipsis: {
            showTitle: false,
          },
        },
        {
          title: "Inform Date",
          dataIndex: "",
          key: "",
          width: 130,
          sorter: (a, b) => a.emp_inform_date.localeCompare(b.emp_inform_date),
          render: (item) => (
            <span>
              {moment(item.emp_inform_date).format("DD/MM/YYYY HH:mm")}
            </span>
          ),
        },
        {
          title: "Assign date",
          key: "plan_start_date",
          width: 150,
          render: (item) => {
            {
              return !item.plan_start_date
                ? "-"
                : moment(item.plan_start_date).format("DD/MM/YYYY HH:mm");
            }
          },
          // sorter: () => null,
          sorter: (a, b) => a.plan_start_date.localeCompare(b.plan_start_date),
        },
        {
          title: "To date",
          key: "plan_end_Date",
          width: 150,
          render: (item) => {
            {
              return item.plan_end_date === null
                ? "-"
                : moment(item.plan_end_date).format("DD/MM/YYYY HH:mm");
            }
          },
          // sorter: () => null,
          sorter: (a, b) => a.plan_end_Date.localeCompare(b.plan_end_Date),
        },
        {
          title: "Inform Detail",
          key: "inform_detail",
          width: 150,
          ellipsis: {
            showTitle: false,
          },
          sorter: (a, b) =>
            (a.inform_detail ? a.inform_detail.length : " ") -
            (b.inform_detail ? b.inform_detail.length : " "),
          render: (item) => (
            <Tooltip
              placement="topLeft"
              title={!item.inform_detail ? "-" : item.inform_detail}
            >
              {!item.inform_detail ? "-" : item.inform_detail}
            </Tooltip>
          ),
        },
        {
          title: "Inform Remark",
          key: "inform_remark",
          width: 150,
          ellipsis: {
            showTitle: false,
          },
          sorter: (a, b) =>
            (a.inform_remark ? a.inform_remark.length : " ") -
            (b.inform_remark ? b.inform_remark.length : " "),
          render: (item) => (
            <Tooltip
              placement="topLeft"
              title={!item.inform_remark ? "-" : item.inform_remark}
            >
              {!item.inform_remark ? "-" : item.inform_remark}
            </Tooltip>
          ),
        },
        {
          title: "Asset Type",
          width: 100,
          ellipsis: {
            showTitle: false,
          },
          render: (item) => {
            return (
              <Tooltip
                placement="topLeft"
                title={!item.asset_type ? "-" : item.asset_type}
              >
                {" "}
                {!item.asset_type ? "-" : item.asset_type}{" "}
              </Tooltip>
            );
          },
        },
        {
          title: "Priority",
          dataIndex: "priority_level",
          sorter: (a, b) => a.priority_level.length - b.priority_level.length,
          width: 70,
          render: (item) => (
            <div>
              {item == "1" ? (
                <span style={{ color: "#618817" }}>Low</span>
              ) : null}
              {item == "2" ? (
                <span style={{ color: "#E8CD00" }}>Normal</span>
              ) : null}
              {item == "3" ? (
                <span style={{ color: "#E09307" }}>High</span>
              ) : null}
            </div>
          ),
        },
        {
          title: "Status",
          dataIndex: "",
          width: 200,
          render: (item) => <div>{item.job_status_name}</div>,
        },
        {
          title: "ผู้สร้าง",
          width: 150,
          render: (item) => (!item.create_by ? "-" : item.create_by),
          key: "create_by",
          sorter: (a, b) =>
            (a.create_by ? a.create_by.length : " ") -
            (b.create_by ? b.create_by.length : " "),
        },
        {
          title: "ผู้รับ",
          width: 150,
          ellipsis: {
            showTitle: false,
          },
          key: "emp_owner_job",
          render: (item) => {
            return (
              <Tooltip
                placement="topLeft"
                title={!item.emp_owner_job ? "-" : item.emp_owner_job}
              >
                {" "}
                {!item.emp_owner_job ? "-" : item.emp_owner_job}{" "}
              </Tooltip>
            );
          },

          sorter: (a, b) =>
            (a.emp_owner_job ? a.emp_owner_job.length : " ") -
            (b.emp_owner_job ? b.emp_owner_job.length : " "),
        },
        {
          title: "SLA คงเหลือ",
          width: 150,
          render: (item) =>
            item.end_sla_date === null ? "-" : dateDiff(item.end_sla_date),
          key: "end_sla_date",
          align: "center",
          sorter: (a, b) =>
            (a.end_sla_date ? a.end_sla_date.length : " ") -
            (b.end_sla_date ? b.end_sla_date.length : " "),
        },
        {
          title: "Last Reason",
          width: 150,
          render: (item) => (item.remark === null ? "-" : item.remark),
          key: "remark",
          align: "center",
          sorter: (a, b) =>
            (a.remark ? a.remark.length : " ") -
            (b.remark ? b.remark.length : " "),
        },
      ],
      columns_employee: [
        {
          title: "",
          // title: <Checkbox onChange={() => this.CheckboxAsset("all")}></Checkbox>,
          dataIndex: "",
          key: "",
          render: (item) => (
            <Checkbox
              onChange={() => this.CheckboxAsset(item)}
              checked={item["status_checkbox"]}
            ></Checkbox>
          ),
        },
        {
          title: "Emp Code",
          dataIndex: "emp_code",
          key: "emp_code",
        },
        {
          title: "Name",
          dataIndex: "emp_name",
          key: "emp_name",
        },
        {
          title: "Nick Name",
          dataIndex: "emp_nickname",
          key: "emp_nickname",
        },
        {
          title: "Skill",
          dataIndex: "ma_skill_name",
          key: "ma_skill_name",
        },
        {
          title: "Team Name",
          dataIndex: "team_name",
          key: "team_name",
        },
        {
          title: "Status",
          dataIndex: "",
          key: "",
          render: (item) => (
            <span>
              {item.working_status === "WO" ? (
                <span className="c-green">
                  <span className="dot-active mr-2"></span>Active
                </span>
              ) : (
                <span className="c-red">
                  <span className="dot-Inactive mr-2"></span> In Active
                </span>
              )}
            </span>
          ),
        },
        {
          title: "On Hand Job",
          dataIndex: "current_onhand_job",
          key: "current_onhand_job",
        },
      ],
      columns_team: [
        {
          title: (
            <Checkbox onChange={() => this.CheckboxAsset("all")}></Checkbox>
          ),
          dataIndex: "",
          key: "",
          render: (item) => (
            <Checkbox
              onChange={() => this.CheckboxAsset(item)}
              checked={item["status_checkbox"]}
            ></Checkbox>
          ),
        },
        // {
        //   title: "Team Group Name",
        //   dataIndex: "team_group_name",
        //   key: "team_group_name",
        // },
        {
          title: "Team Sub Name",
          dataIndex: "team_sub_name",
          key: "team_sub_name",
        },
        {
          title: "Name List",
          dataIndex: "emp_name",
          key: "emp_name",
        },
        {
          title: "Status",
          dataIndex: "",
          key: "",
          render: () => (
            <span className="c-green">
              <span className="dot-active mr-2"></span>Active
            </span>
          ),
        },
        {
          title: "On Hand Job",
          dataIndex: "current_onhand_job",
          key: "current_onhand_job",
        },
      ],
      datateam: [],
      Checktab: 1,
      data_wf: [],
      sc_type: {},
      selectedRowlist: [],
      factupdate: false,
      data_translate: [],
      btnName: "",
      process_tab: "",
      WorkFlow: [],
      checkType: "",
      visible_cancel: false,
      data_cancel: [],
      active_category: 0,
      default_key: 1,
      data_tab_category: [],
      data_table_list: [],
      job_category_id: null,
      reloading: false,
      selectedRowKeys: [],
      selectedRows: [],
      master_emp: [],
      visible_reassign: false,
      modalstatus: false,
      data_reassign: [],
      qury_tab: "",
      emp_assign: [],
      list_vendor: [],
      vendor_id: "",
      visible_modal_approve: false,
      dataapprove: [],
      status_wait_approve: [
        { value: "Review Stop Time", text: "Stop Time" },
        { value: "Wait TL Approve/Reject", text: "Wait TL Approve" },
      ],
      value_status: "Wait TL Approve/Reject",
      master_data: [],
      active_emp_skill: 0,
      active_tab_skill: 1,
      startDate: new Date(),
      checkBtnAssign: 0,
      checkboxAll: false,
      assign_date: [],
      data_export: [],
      visible_export: false,
      file_name: "",
      status_cancel: [],
      visible_status_modal_cancel: false,
      display_status_cancel: [],
      reject_service_ma_remark: "",
      disible_assign: false,
      master_jobcategory: [],
      job_id: "",
      loading_checklist: false,
    };
  }
  async componentDidMount() {
    document.title = "MA List";
    Cookies.remove("job_id");
    localStorage.removeItem("editjob");
    localStorage.removeItem("StatusLocal");
    localStorage.removeItem("informDetail");
    localStorage.removeItem("active");
    var setjobCategory = [];

    var setmaskill = {
      pk_id: null,
      is_active: 1,
      effective: null,
      sql_where: "operator_id = " + Cookies.get("operator_id"),
      company_id: Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
    };
    const GetJobstatus = await Api.post("get_job_status", {
      pk_id: null,
      fk_id: null,
      is_active: 1,
      effective: null,
      sql_where: null,
      company_id: Cookies.get("companyid"),
    });
    const GetJobCategoty = await Api.post("get_job_category_V2", {
      company_id: Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
      project_id: Cookies.get("project_id"),
      job_category_id: null,
      is_active: 1,
      date_active: 1,
      operator_id: Cookies.get("operator_id"),
    });
    const data_language = await Api.post("master_language_detail_get", {
      company_id: Cookies.get("companyid"),
      page_id: 1,
    });

    setjobCategory.push(
      {
        job_category_id: null,
        job_category_name: "All Job Category",
        job_category_count: 0,
      },
      ...GetJobCategoty.data.data.result_data
    );
    GetJobstatus.data.data.job_status_dto_list.push({
      status_desc: "All Status",
      status_id: null,
    });

    this.JobCategoryList(0, setjobCategory[0], setjobCategory);
    this.setState({
      data_tab_category: setjobCategory[0],
      sc_status: GetJobstatus.data.data.job_status_dto_list,
      master_jobcategory: setjobCategory,
      factupdate: true,
      selectedRowlist: [],
      data_translate: JSON.parse(
        data_language.data.data["masteR_LANGUAGE_DETAIL"][0].file_json
      ),

      // loading: false,
    });
    const GetMaskill = await Api.post("get_ma_skill", setmaskill);
    const GetMaTeam = await Api.post("get_team_group", {
      pk_id: null,
      is_active: "1",
      effective: null,
      sql_where: null,
      company_id: Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
    });
    if (GetMaTeam.data.result.value === "P") {
      this.setState({ ma_team: GetMaTeam.data.data.team_group_list });
    }
    if (GetMaskill.data.result.value === "P") {
      this.setState({ ma_skill: GetMaskill.data.data.result_ma_skill_list });
      await this.onChangEmp(1, 0);
    }
  }
  CheckboxAsset = (value) => {
    if (value === "all") {
      for (let i = 0; i < this.state.data_assing.length; i++) {
        this.state.data_assing[i]["status_checkbox"] =
          !this.state.data_assing[i]["status_checkbox"];
        if (this.state.data_assing[i]["status_checkbox"] === true) {
          this.state.emp_assign.push(this.state.data_assing[i]);
        } else {
          const result = this.state.emp_assign.filter(
            (data) => data.employee_id !== this.state.data_assing[i].employee_id
          );
          this.setState({
            emp_assign: result,
          });
        }
      }
      this.setState({
        data_assing: this.state.data_assing,
      });
    } else {
      value["status_checkbox"] = !value["status_checkbox"];
      this.setState({
        data_assing: this.state.data_assing,
      });
      if (value["status_checkbox"] === true) {
        this.state.emp_assign.push(value);
      } else {
        const result = this.state.emp_assign.filter(
          (data) => data.employee_id !== value.employee_id
        );
        this.setState({
          emp_assign: result,
        });
      }
    }
  };
  btneditjob = async (data) => {
    localStorage.setItem("editjob", JSON.stringify(data));
    localStorage.setItem("StatusLocal", 1);
    window.location.assign("/MaxiOperation/editjob");
  };
  handleOptionSearch = (value) => {
    this.setState({ current_option: value });
  };
  onModal = async (visible, item, name) => {
    const get_vendor = await Api.post("get_vendor", {
      company_id: Cookies.get("companyid"),
      operator_id: null,
      project_id: null,
      vendor_id: null,
      vendor_code: null,
      vendor_name: null,
      vendor_address: null,
      v_where: null,
    });

    this.setState({
      list_vendor: get_vendor.data.data.result,
    });
    if (visible === false) {
      for (let i = 0; i < this.state.data_assing.length; i++) {
        this.state.data_assing[i]["status_checkbox"] = false;
        this.state.data_assing[i]["rowKey"] = i;
      }
      this.setState({
        visible: visible,
        visible_detail: visible,
        data_assing: this.state.data_assing,
        modal_data: [],
        // data_assing: [],
      });
    } else {
      if (name === "assignMulti" || name === "Wait Ack Job Multi") {
        await this.setState({
          loading_checklist: true,
        });
        // var setJobId = "";
        var subid = "";
        var WorkFlow_Loop = [];
        var prev_wf_id = null;
        var prev_main_process_id = null;
        var prev_sub_process_id = null;
        var prev_workflow = [];

        this.state.selectedRowlist.sort((a, b) =>
          a.wf_id > b.wf_id ? 1 : b.wf_id > a.wf_id ? -1 : 0
        );
        for (var i = 0; i < this.state.selectedRowlist.length; i++) {
          // setJobId += this.state.selectedRowlist[i].job_no + ",";
          subid =
            this.state.selectedRowlist[i].subprocessid === null
              ? (subid = "-1")
              : (subid = this.state.selectedRowlist[i].subprocessid);

          if (
            this.state.selectedRowlist[i].wf_id != prev_wf_id &&
            this.state.selectedRowlist[i].main_process_id !=
            prev_main_process_id &&
            subid != prev_sub_process_id
          ) {
            const getBtn = await Api.post("getButtonDetailWeb", {
              WF_ID: this.state.selectedRowlist[i].wf_id,
              CompanyID: this.state.selectedRowlist[i].company_id,
              ProjectID: this.state.selectedRowlist[i].project_id,
              JobTypeID: this.state.selectedRowlist[i].job_type_id,
              MainProcessID:
                this.state.selectedRowlist[i].main_process_id === null
                  ? 1
                  : this.state.selectedRowlist[i].main_process_id,
              SubProcessID: subid,
              ActionID: this.state.selectedRowlist[i].actionid,
              UserName: Cookies.get("username"),
            });

            var checkflow = getBtn.data.return_nextWorkFlow.find(
              (element) =>
                element.next_main_action_name === "Assign" ||
                element.next_main_action_name === "Reassign" ||
                element.from_main_process_name === "Wait Ack Job"
            );
            WorkFlow_Loop.push(checkflow);
            prev_wf_id = this.state.selectedRowlist[i].wf_id;
            prev_main_process_id =
              this.state.selectedRowlist[i].main_process_id;
            prev_sub_process_id = subid;
            prev_workflow = checkflow;
          } else {
            WorkFlow_Loop.push(prev_workflow);
          }
        }

        await this.setState({
          loading_checklist: false,
          visible: visible,
          job_id: "Total " + this.state.selectedRowlist.length + " Jobs",
          modal_data: this.state.selectedRowlist,
          data_wf: WorkFlow_Loop,
          btnName: name === "Wait Ack Job Multi" ? "Edit Employee" : checkflow.next_main_action_name,
        });
      } else {
        var subid =
          item.subprocessid === null
            ? (subid = "-1")
            : (subid = item.subprocessid);
        const getBtn = await Api.post("getButtonDetailWeb", {
          WF_ID: item.wf_id,
          CompanyID: item.company_id,
          ProjectID: item.project_id,
          JobTypeID: item.job_type_id,
          MainProcessID: item.main_process_id,
          SubProcessID: subid,
          ActionID: item.actionid,
          UserName: Cookies.get("username"),
          operator_id: Cookies.get("operator_id"),
        });
        var checkflow = getBtn.data.return_nextWorkFlow.find(
          (element) =>
            element.next_main_action_name === "Assign" ||
            element.next_main_action_name === "Reassign" ||
            element.from_main_process_name === "Wait Ack Job"
        );
        this.setState({
          visible: visible,
          job_id: item.job_no,
          modal_data: item,
          data_wf: checkflow,
          btnName: name === "Wait Ack Job" ? "Edit Employee" : checkflow.next_main_action_name,
        });
      }
    }
  };
  async handleSubmit(modal_data) {
    this.setState({
      disible_assign: true,
    });
    var setAssign = {};
    var setsubmit = [];
    var setTab = ["", "employee_id", "team_id"];
    var setTab_flag = ["", "E", "T"];

    if (modal_data.length > 1) {
      for (var r = 0; r < modal_data.length; r++) {
        for (var i = 0; i < this.state.emp_assign.length; i++) {
          if (setTab_flag[this.state.Checktab] == "E") {
            setAssign = {
              job_no: modal_data[r].job_no,
              emp_code: this.state.emp_assign[i][setTab[this.state.Checktab]],
              create_by: Cookies.get("username"),
              company_id: Cookies.get("companyid"),
              operator_id: Cookies.get("operator_id"),
              job_progress_id: modal_data[r].job_progress_id,
              project_id: Cookies.get("project_id"),
              ...this.state.data_wf[r],
              flag_reassign: "assign",
              emp_or_team: setTab_flag[this.state.Checktab],
              job_id: modal_data[r].job_id,
              team_id: "",
              team_group_id: "",
              vendor_id: this.state.vendor_id,

              plan_start_date:
                this.state.assign_date.length === 0
                  ? moment(modal_data[r].plan_start_date).format(
                    "YYYY-MM-DD HH:mm:ss"
                  )
                  : moment(this.state.assign_date).format(
                    "YYYY-MM-DD HH:mm:ss"
                  ),
              plan_end_date:
                modal_data[r].plan_end_date === null
                  ? moment(modal_data[r].plan_start_date)
                    .subtract(7, "d")
                    .format("YYYY-MM-DD HH:mm:ss")
                  : moment(modal_data[r].plan_end_date).format(
                    "YYYY-MM-DD HH:mm:ss"
                  ),
            };
            setsubmit.push(setAssign);
          } else {
            setAssign = {
              job_no: modal_data[r].job_no,
              emp_code: "",
              create_by: Cookies.get("username"),
              company_id: Cookies.get("companyid"),
              operator_id: Cookies.get("operator_id"),
              job_progress_id: modal_data[r].job_progress_id,
              project_id: Cookies.get("project_id"),
              ...this.state.data_wf[r],
              flag_reassign: "assign",
              emp_or_team: setTab_flag[this.state.Checktab],
              job_id: modal_data[r].job_id,
              team_id: this.state.emp_assign[i].team_id,
              team_group_id: this.state.emp_assign[i].team_group_id,
              vendor_id: this.state.vendor_id,

              plan_start_date:
                this.state.assign_date.length === 0
                  ? moment(modal_data[r].plan_start_date).format(
                    "YYYY-MM-DD HH:mm:ss"
                  )
                  : moment(this.state.assign_date).format(
                    "YYYY-MM-DD HH:mm:ss"
                  ),
              plan_end_date:
                modal_data[r].plan_end_date === null
                  ? moment(modal_data[r].plan_start_date)
                    .subtract(7, "d")
                    .format("YYYY-MM-DD HH:mm:ss")
                  : moment(modal_data[r].plan_end_date).format(
                    "YYYY-MM-DD HH:mm:ss"
                  ),
            };
            setsubmit.push(setAssign);
          }
        }
      }
    } else {
      for (var i = 0; i < this.state.emp_assign.length; i++) {
        if (setTab_flag[this.state.Checktab] == "E") {
          setAssign = {
            job_no: modal_data.job_no,
            emp_code: this.state.emp_assign[i][setTab[this.state.Checktab]],
            create_by: Cookies.get("username"),
            company_id: Cookies.get("companyid"),
            operator_id: Cookies.get("operator_id"),
            job_progress_id: modal_data.job_progress_id,
            project_id: Cookies.get("project_id"),
            ...this.state.data_wf,
            flag_reassign: "assign",
            emp_or_team: setTab_flag[this.state.Checktab],
            job_id: modal_data.job_id,
            team_id: "",
            team_group_id: "",
            vendor_id: this.state.vendor_id,

            plan_start_date:
              this.state.assign_date.length === 0
                ? moment(modal_data.plan_start_date).format(
                  "YYYY-MM-DD HH:mm:ss"
                )
                : moment(this.state.assign_date).format("YYYY-MM-DD HH:mm:ss"),
            plan_end_date:
              modal_data.plan_end_date === null
                ? moment(modal_data.plan_start_date)
                  .subtract(7, "d")
                  .format("YYYY-MM-DD HH:mm:ss")
                : moment(modal_data.plan_end_date).format(
                  "YYYY-MM-DD HH:mm:ss"
                ),
          };
          setsubmit.push(setAssign);
        } else {
          setAssign = {
            job_no: modal_data.job_no,
            emp_code: "",
            create_by: Cookies.get("username"),
            company_id: Cookies.get("companyid"),
            operator_id: Cookies.get("operator_id"),
            job_progress_id: modal_data.job_progress_id,
            project_id: Cookies.get("project_id"),
            ...this.state.data_wf,
            flag_reassign: "assign",
            emp_or_team: setTab_flag[this.state.Checktab],
            job_id: modal_data.job_id,
            team_id: this.state.emp_assign[i].team_id,
            team_group_id: this.state.emp_assign[i].team_group_id,
            vendor_id: this.state.vendor_id,

            plan_start_date:
              this.state.assign_date.length === 0
                ? moment(modal_data.plan_start_date).format(
                  "YYYY-MM-DD HH:mm:ss"
                )
                : moment(this.state.assign_date).format("YYYY-MM-DD HH:mm:ss"),
            plan_end_date:
              modal_data.plan_end_date === null
                ? moment(modal_data.plan_start_date)
                  .subtract(7, "d")
                  .format("YYYY-MM-DD HH:mm:ss")
                : moment(modal_data.plan_end_date).format(
                  "YYYY-MM-DD HH:mm:ss"
                ),
          };

          setsubmit.push(setAssign);
        }
      }
    }
    const getTeamAssign = await Api.post(this.state.btnName === "Edit Employee" ? "V3/update_job_ma_to_employee_vendor" : "V2/update_job_ma_to_employee_vendor", setsubmit
    );
    if (getTeamAssign.data.result.value == "P") {
      this.setState((state) => {
        const data = state.data.map((item) => {
          if (item.job_id === modal_data.job_id) {
            item.job_point = 1;
            this.setState({
              emp_assign: [],
            });
            return item;
          } else {
            return item;
          }
        });
        return {
          data,
          visible: false,
          visible_success: true,
        };
      });
    } else {
      this.setState({
        disible_assign: false,
      });
      alert("Error Submit");
    }
  }
  CancelAssign = async () => {
    var dataset = [];
    var status_cancel = [];
    if (this.state.data_cancel.length === undefined) {
      dataset.push({
        company_id: Cookies.get("companyid"),
        operator_id: this.state.data_cancel.operator_id,
        project_id: this.state.data_cancel.project_id,
        job_id: this.state.data_cancel.job_id,
        job_progress_id: this.state.data_cancel.job_progress_id,
        location_lat: "",
        location_long: "",
        create_by: Cookies.get("username"),
      });
    } else {
      for (let i = 0; i < this.state.data_cancel.length; i++) {
        if (this.state.data_cancel[i].job_progress_id === null) {
          status_cancel.push(this.state.data_cancel[i]);
        } else {
          dataset.push({
            company_id: Cookies.get("companyid"),
            operator_id: this.state.data_cancel[i].operator_id,
            project_id: this.state.data_cancel[i].project_id,
            job_id: this.state.data_cancel[i].job_id,
            job_progress_id: this.state.data_cancel[i].job_progress_id,
            location_lat: "",
            location_long: "",
            create_by: Cookies.get("username"),
            job_no: this.state.data_cancel[i].job_no,
          });
        }
      }
    }
    this.setState({ status_cancel });
    const CancelAssign = await Api.post("update_oper_job_cancel_list", dataset);
    if (CancelAssign.data.result.code === "P") {
      if (status_cancel.length > 0) {
        this.setState({
          display_status_cancel: dataset,
          visible_status_modal_cancel: true,
        });
      } else {
        window.location.reload();
      }
    } else {
      alert("Error");
    }
  };
  onChangeasset = async (val, obj, name) => {
    const qury_process = [
      "",
      "and job_status  not in (999)",
      "and job_status  in (2,3)",
      "and job_status  in (1)",
    ];
    const SetSc = this.state.sc_type;
    SetSc[obj.type_sc] = val;
    const getalljob = await Api.post("oper_get_query_group_list", {
      company_id: Cookies.get("companyid"),
      operator_id: 0,
      project_id: 0,
      query_module: "oper",
      query_id: "2,3,4,5,6",
      param_text: `@company_id:$${Cookies.get(
        "companyid"
      )}##@operator_id:$${Cookies.get(
        "operator_id"
      )}##@project_id:$${Cookies.get(
        "project_id"
      )}##@select:$null##@job_status_id:$${SetSc["status"] !== undefined ? SetSc["status"] : null
        }##@category_id:$${SetSc["job_Category"] != undefined ? SetSc["job_Category"] : null
        }##@date:$null##@job_type:$null##@priority_id:$${SetSc["sc_Priority"] != undefined ? SetSc["sc_Priority"] : null
        }##@create_by:$${Cookies.get(
          "userId"
        )}##@job_sub_type_id:$null##@sql_where:$'${obj.length === 2 && val != null
          ? qury_process[this.state.statustab] +
          "and DATE_FORMAT(emp_inform_date,'%Y-%m-%d') between'" +
          obj[0] +
          "' and '" +
          obj[1] +
          "'"
          : qury_process[this.state.statustab]
        }'`,
      where_cond: "",
    });

    if (getalljob.data.result.code.toLowerCase() == "p") {
      for (var i = 0; i < getalljob.data.data.result_ma_job_list.length; i++) {
        getalljob.data.data.result_ma_job_list["key"] = i;
      }
      for (let i = 0; i < this.state.master_jobcategory.length; i++) {
        const count_job_cat = getalljob.data.data.result_count.filter(
          (data) =>
            data.job_category_id ===
            this.state.master_jobcategory[i].job_category_id
        );
        if (count_job_cat.length === 0) {
          this.state.master_jobcategory[i]["job_category_count"] = 0;
        } else {
          this.state.master_jobcategory[i]["job_category_count"] =
            count_job_cat[0]["counter"];
        }
      }

      this.setState({
        checkType: obj.type,
        job_category: this.state.master_jobcategory,
        data_export: getalljob.data.data,
        data: getalljob.data.data.result_ma_job_list,
        master_data: getalljob.data.data.result_ma_job_list,
        data_table_list: getalljob.data.data.result_ma_job_list,
        alljob: getalljob.data.data.result_job_status[0].total_job,
        onprocess: getalljob.data.data.result_job_status[0].on_process,
        Urgent_total: getalljob.data.data.result_count_priority[0].urgent,
        High_total: getalljob.data.data.result_count_priority[0].heigh,
        Normal_total: getalljob.data.data.result_count_priority[0].normal,
        Low_total: getalljob.data.data.result_count_priority[0].low,
        loading: false,
        statustab: this.state.statustab,
        sum_wait_assign: getalljob.data.data.result_job_status[0].reassign,
        sum_approve: getalljob.data.data.result_job_status[0].waitApprove,
        sum_alljob: getalljob.data.data.result_job_status[0].total_job,
        sum_onprocess: getalljob.data.data.result_job_status[0].on_process,
        sum_no_assing: getalljob.data.data.result_job_status[0].no_assign,
      });
    } else {
      this.setState({
        loading: false,
      });
    }
  };
  onChangEmp = async (val, index) => {
    this.setState({
      data_assing: [],
      reloading: true,
      active_emp_skill: index,
    });
    var setTab = ["", "employee", "team"];
    const getTeamAssign = await Api.post("v2/get_assign_job_ma", {
      select: setTab[this.state.Checktab],
      skill_id: val,
      team_id: null,
      company_id: Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
      project_id: Cookies.get("project_id"),
      sql_where: "operator_id=" + Cookies.get("operator_id"),
    });
    if (this.state.Checktab === "1" || this.state.Checktab === 1) {
      for (
        var i = 0;
        i < getTeamAssign.data.data.result_list_ma_employee.length;
        i++
      ) {
        getTeamAssign.data.data.result_list_ma_employee[i]["key"] = i;
        getTeamAssign.data.data.result_list_ma_employee[i][
          "status_checkbox"
        ] = false;
        getTeamAssign.data.data.result_list_ma_employee[i]["id"] = i;
        for (let r = 0; r < this.state.emp_assign.length; r++) {
          if (
            this.state.emp_assign[r].employee_id ===
            getTeamAssign.data.data.result_list_ma_employee[i].employee_id
          ) {
            getTeamAssign.data.data.result_list_ma_employee[i]["status_checkbox"] = true;
          }
        }
      }
      this.setState({
        master_emp: getTeamAssign.data.data.result_list_ma_employee,
        data_assing: getTeamAssign.data.data.result_list_ma_employee,
        reloading: false,
      });
    } else if (this.state.Checktab === "2" || this.state.Checktab === 2) {
      for (
        var i = 0;
        i < getTeamAssign.data.data.result_list_ma_team.length;
        i++
      ) {
        getTeamAssign.data.data.result_list_ma_team[i]["key"] = i;
        getTeamAssign.data.data.result_list_ma_team[i][
          "status_checkbox"
        ] = false;
        getTeamAssign.data.data.result_list_ma_team[i]["id"] = i;
        for (let r = 0; r < this.state.emp_assign.length; r++) {
          if (
            this.state.emp_assign[r].employee_id ===
            getTeamAssign.data.data.result_list_ma_team[i].employee_id
          ) {
            getTeamAssign.data.data.result_list_ma_team[i][
              "status_checkbox"
            ] = true;
          }
        }
      }
      this.setState({
        master_emp: getTeamAssign.data.data.result_list_ma_team,
        data_assing: getTeamAssign.data.data.result_list_ma_team,
        reloading: false,
      });
    }
  };
  onSelectChange = (selectedRowKeys, selectedRows) => {
    const { Checktab, default_key } = this.state;
    this.setState({ selectedRowKeys });
    this.setState({
      setDataAssign: selectedRows,
    });
  };
  SearchDataAssign = (value) => {
    const tempFilteredData = this.state.master_emp.filter((o) =>
      Object.keys(o).some((k) =>
        String(o[k]).toLowerCase().includes(value.toLowerCase())
      )
    );
    this.setState({
      data_assing: tempFilteredData,
    });
  };
  renderModalAssign() {
    const {
      employee,
      team,
      visible,
      job_id,
      columns,
      setDataAssign,
      Checktab,
      default_key,
      selectedRowKeys,
      selectedRows,
      reloading,
    } = this.state;
    const rowSelection = {
      selectedRowKeys,
      selectedRows,
      onChange: this.onSelectChange,
      getCheckboxProps: (record) => ({
        disabled: record.name === "Disabled User",
        name: record.name,
      }),
    };
    const dateFormatList = ["DD/MM/YYYY", "DD/MM/YY"];
    return (
      <Modal
        title={null}
        centered
        visible={visible}
        footer={null}
        closable={false}
        width={1000}
        className="custom-modal-map-large"
      >
        <div className="row">
          <div className="col-12">
            {" "}
            <h5 className="font-mont-b font14 c-blue text-uppercase mt-4 ml-4">
              Assign Job : {job_id}
            </h5>
          </div>
          <div className="col-3">
            {/* <AssignJob data={this.state.modal_data} /> */}
            <div className="row  mt-2 ml-4">
              <div
                className={
                  this.state.active_tab_skill === 1
                    ? "col-6 setAcive"
                    : "col-6 setnonAcive"
                }
                onClick={() => this.setDataTabEMP(1)}
              >
                <span>Employee</span>{" "}
              </div>
              <div
                className={
                  this.state.active_tab_skill === 2
                    ? "col-6 setAcive"
                    : "col-6 setnonAcive"
                }
                onClick={() => this.setDataTabEMP(2)}
              >
                <span>Team</span>{" "}
              </div>
            </div>
            <div className="row  mt-2 ml-4 setoverflowCard">
              {this.state.ma_skill.map((item, index) => (
                <div
                  className="col-12"
                  onClick={() => this.onChangEmp(item.ma_skill_id, index)}
                  key={index}
                >
                  <div
                    className={
                      this.state.active_emp_skill === index
                        ? "boxcradAcive mb-2"
                        : "boxcradnonAcive mb-2"
                    }
                  >
                    <span
                      className={
                        this.state.active_emp_skill === index
                          ? "settextcardActive mb-2"
                          : "settextcardnonActive mb-2"
                      }
                    >
                      {item.ma_skill_name}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="col-9">
            <div style={{ padding: "20px" }}>
              <div className="row">
                <div className="col-auto ">
                  <h5 className="font-mont-b fs-10 c-blue text-uppercase mt-2">
                    Assign Date :
                  </h5>
                </div>
                <div className="col-4 ">
                  <DatePicker
                    onChange={(e) => this.setState({ assign_date: e })}
                    style={{ color: "#000F9F" }}
                    name="date"
                  />
                </div>
                <div className="col-auto">
                  <h5 className="font-mont-b fs-10 c-blue text-uppercase mt-2">
                    Assign Vendor :
                  </h5>
                </div>
                <div className="col-4">
                  <Select
                    showSearch
                    style={{ border: "0px", width: "100%", color: "#000F9F" }}
                    placeholder="Please Select"
                    className="inputfile"
                    onChange={(value) => this.setState({ vendor_id: value })}
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.children === "" || option.children === null
                        ? null
                        : option.children
                          .toLowerCase()
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {this.state.list_vendor.map((item, index) => (
                      <Select.Option value={item.vendor_id} key={index}>
                        {item.vendor_name}
                      </Select.Option>
                    ))}
                  </Select>
                </div>
                <div className="col-12 mt-2">
                  <Input
                    placeholder="Search"
                    style={{
                      fontSize: "10px",
                      marginBottom: "10px",
                      height: "33px",
                      borderRadius: "0px",
                      maxWidth: "45%",
                    }}
                    onChange={(e) => this.SearchDataAssign(e.target.value)}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  {this.state.active_tab_skill === 1 ? (
                    <Table
                      loading={this.state.loading}
                      size="small"
                      rowKey="key"
                      columns={this.state.columns_employee}
                      dataSource={
                        !this.state.data_assing ? null : this.state.data_assing
                      }
                      style={{
                        whiteSpace: "nowrap",
                        lineHeight: "0.7 !important",
                      }}
                    />
                  ) : null}
                  {this.state.active_tab_skill === 2 ? (
                    <Table
                      loading={this.state.loading}
                      size="small"
                      rowKey="team_id"
                      columns={this.state.columns_team}
                      dataSource={
                        !this.state.data_assing ? null : this.state.data_assing
                      }
                      style={{
                        whiteSpace: "nowrap",
                        lineHeight: "0.7 !important",
                      }}
                    />
                  ) : null}
                </div>
              </div>
            </div>
          </div>
          <div className="col-12">
            <div className="mb-2 text-center">
              <button
                type="reset"
                onClick={() => this.onModal(false)}
                className="btn btn-secondary"
              >
                Close
              </button>
              <button
                className={
                  this.state.disible_assign
                    ? "divhide"
                    : "btn btn-success divshow"
                }
                onClick={() => this.handleSubmit(this.state.modal_data)}
              >
                {this.state.btnName}
              </button>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
  renderModalApproveSuccess() {
    const { visible_success } = this.state;
    return (
      <Modal
        title={null}
        centered
        visible={visible_success}
        footer={null}
        closable={false}
      >
        <div className="text-center">
          <img
            src={Api.absoluteUrl("/img/modal_success.svg")}
            className="img-fluid"
          />
          <h3 className="font-mont-sb font18 c-blue mt-3">
            Assign Job Successful
          </h3>
          <button
            className="btn btn-primary"
            onClick={() => this.setState({ visible_success: false })}
          >
            {this.state.visible_success === false
              ? window.location.reload()
              : null}
            Ok
          </button>
        </div>
      </Modal>
    );
  }
  renderModalCancelAssign() {
    return (
      <>
        <Modal
          title={null}
          centered
          visible={this.state.visible_cancel}
          footer={null}
          closable={false}
        >
          <div className="text-center">
            <img
              src={Api.absoluteUrl("/img/modal_success.svg")}
              className="img-fluid"
            />
            <h3 className="font-mont-sb font18 c-blue mt-3">
              Cancel Assign Job {this.state.data_cancel.job_no}
            </h3>
            <button
              className="btn-secondary"
              onClick={() => this.setState({ visible_cancel: false })}
            >
              Close
            </button>
            <button className="btn-primary" onClick={() => this.CancelAssign()}>
              {/* {this.state.visible_success === false
              ? window.location.reload()
              : null} */}
              Ok
            </button>
          </div>
        </Modal>
        <Modal
          title={null}
          centered
          visible={this.state.visible_status_modal_cancel}
          footer={null}
          closable={false}
        >
          <div className="text-center">
            <img
              src={Api.absoluteUrl("/img/modal_success.svg")}
              className="img-fluid"
            />
            <h3 className="font-mont-sb font18 c-blue mt-3">
              {this.state.status_cancel.length > 0 ? (
                <div className="row">
                  <div className="col-12">
                    {"กรุณาติดต่อ Admin ไม่สามารถ Cancel Job"}
                  </div>
                  {this.state.status_cancel.map((item, index) => (
                    <>
                      <div className="col-12 mt-1">
                        <span>{item.job_no}</span>
                      </div>
                    </>
                  ))}
                </div>
              ) : (
                "Cancel Assign Job Success"
              )}
            </h3>
            <button
              className="btn-secondary"
              onClick={() => window.location.reload()}
            >
              Close
            </button>
          </div>
        </Modal>
      </>
    );
  }
  async tabjob(item, status) {
    await this.setState({
      loading: true,
      statustab: item,
      data_table_list: [],
      selectedRowlist: [],
      checkboxAll: false,
    });
    localStorage.setItem("default_tab_number", item);
    var DataWorkFlow = [];
    if (status === "No Assignment") {
      DataWorkFlow = this.state.WorkFlow.filter(
        (element) => element.process_desc === status
      );
    }
    if (status === "Wait Re-Assign") {
      DataWorkFlow = this.state.WorkFlow.filter(
        (element) =>
          element.process_desc === status || element.process_desc === "Reject"
      );
    }
    if (status === "Wait Approve") {
      DataWorkFlow = this.state.WorkFlow.filter(
        (element) =>
          element.process_desc === status ||
          element.process_desc === "Wait TL Approve/Reject"
      );
    }
    if (
      status != "Wait Re-Assign" &&
      status != "No Assignment" &&
      status != "Wait Approve" &&
      status != "Wait TL Approve/Reject"
    ) {
      DataWorkFlow = this.state.WorkFlow.filter(
        (element) =>
          element.process_desc === status || element.process_desc === "Assign"
      );
    }
    var qury = "and (job_status in ( ";
    for (let r = 0; r < DataWorkFlow.length; r++) {
      qury += DataWorkFlow[r].process_id + ",";
    }

    qury = qury.substring(qury, qury.length - 1) + ")";
    const getalljob = await Api.post("oper_get_query_group_list", {
      company_id: Cookies.get("companyid"),
      operator_id: 0,
      project_id: 0,
      query_module: "oper",
      query_id: "2,3,4,5,6",
      param_text: `@company_id:$${Cookies.get(
        "companyid"
      )}##@operator_id:$${Cookies.get(
        "operator_id"
      )}##@project_id:$${Cookies.get(
        "project_id"
      )}##@select:$null##@job_status_id:$${!isEmpty(this.state.sc_type) ? this.state.sc_type.status : null
        }##@category_id:$${this.state.job_category_id
        }##@date:$null##@job_type:$null##@priority_id:$${!isEmpty(this.state.sc_type) ? this.state.sc_type.sc_Priority : null
        }##@create_by:$${Cookies.get(
          "userId"
        )}##@job_sub_type_id:$null##@sql_where:$'${status === "ALL JOB"
          ? "and job_status not in (999)"
          : status === "Wait Approve"
            ? qury +
            ` or concat(j.next_main_process_id,ifnull( j.next_sub_process_id,- ( 1 ) )) in ("318" , "320" , "321"))`
            : qury + ")"
        }'`,
      where_cond: "",
    });
    if (getalljob.data.result.code.toLowerCase() === "p") {
      this.setState({
        qury_tab:
          status === "ALL JOB"
            ? "and job_status not in (999)"
            : status === "Wait Approve"
              ? qury +
              ` or concat(j.next_main_process_id,ifnull( j.next_sub_process_id,- ( 1 ) )) in ("318" , "320" , "321"))`
              : qury + ")",
      });
      if (hasFilteredValue !== "") {
        getalljob.data.data.result_ma_job_list =
          getalljob.data.data.result_ma_job_list.filter((item) =>
            filteredData.find((j) => j.job_id === item.job_id)
          );
      }
      for (
        var i = 0;
        i <
        (getalljob.data.data === null
          ? 0
          : getalljob.data.data.result_ma_job_list.length);
        i++
      ) {
        getalljob.data.data.result_ma_job_list[i]["key"] = i;
      }

      localStorage.setItem(
        "default_tab",
        JSON.stringify(
          status === "ALL JOB"
            ? "and job_status not in (999)"
            : status === "Wait Approve"
              ? qury +
              ` or concat(j.next_main_process_id,ifnull( j.next_sub_process_id,- ( 1 ) )) in ("318" , "320" , "321"))`
              : qury + ")"
        )
      );

      for (let i = 0; i < getalljob.data.data.result_ma_job_list.length; i++) {
        getalljob.data.data.result_ma_job_list[i]["status_checkbox"] = false;
        getalljob.data.data.result_ma_job_list[i]["id"] = i;
      }
      let sum = 0;
      for (let i = 0; i < this.state.master_jobcategory.length; i++) {
        const count_job_cat = getalljob.data.data.result_count.filter(
          (data) =>
            data.job_category_id ===
            this.state.master_jobcategory[i].job_category_id
        );
        if (count_job_cat.length === 0) {
          this.state.master_jobcategory[i]["job_category_count"] = 0;
        } else {
          this.state.master_jobcategory[i]["job_category_count"] =
            count_job_cat[0]["counter"];
        }
        sum +=
          this.state.master_jobcategory[i].job_category_count != null
            ? this.state.master_jobcategory[i].job_category_count
            : 0;
      }
      this.state.master_jobcategory[0].job_category_count = sum;
      this.setState({
        data_table_list: getalljob.data.data.result_ma_job_list,
        loading: false,
        job_category: this.state.master_jobcategory,
        data_export: getalljob.data.data,
        data: getalljob.data.data.result_ma_job_list,
        master_data: getalljob.data.data.result_ma_job_list,
        Urgent_total: getalljob.data.data.result_count_priority[0].urgent,
        High_total: getalljob.data.data.result_count_priority[0].heigh,
        Normal_total: getalljob.data.data.result_count_priority[0].normal,
        Low_total: getalljob.data.data.result_count_priority[0].low,
        sum_wait_assign: getalljob.data.data.result_job_status[0].reassign,
        sum_approve: getalljob.data.data.result_job_status[0].waitApprove,
        sum_alljob: getalljob.data.data.result_job_status[0].total_job,
        sum_onprocess: getalljob.data.data.result_job_status[0].on_process,
        sum_no_assing: getalljob.data.data.result_job_status[0].no_assign,
      });
      if (status === "Wait Approve") {
        this.filterStatusApprove("Wait TL Approve/Reject");
      }
    } else {
      this.setState({
        loading: false,
      });
    }
  }
  renderModalReassign() {
    return (
      <Modal
        title={<span className="font-mont-sb font18 c-blue">Reassign</span>}
        centered
        visible={this.state.visible_reassign}
        footer={null}
        closable={false}
      >
        <Form onFinish={(values) => this.submitReasign()} layout="vertical">
          <Form.Item
            name="reason"
            label={<div className="font-mont-m font12">Reason</div>}
            rules={[
              {
                required: true,
                message: "โปรดเขียนรายละเอียด",
              },
            ]}
          >
            <Input.TextArea
              rows={4}
              placeholder="เขียนรายละเอียด"
              onChange={(e) =>
                this.setState({
                  reject_service_ma_remark: e.target.value,
                })
              }
            />
          </Form.Item>
          <Form.Item className="mb-0 text-center">
            <button
              type="reset"
              onClick={() => this.setState({ visible_reassign: false })}
              className="btn btn-secondary"
            >
              Cancel
            </button>
            <button className="btn btn-danger">Reassign</button>
          </Form.Item>
        </Form>
      </Modal>
    );
  }
  onHandlereassign = async (data, type) => {
    if (type === "multireassign") {
      this.setState({ visible_reassign: true });
      var DataReassign = [];
      var prev_wf_id = null;
      var prev_main_process_id = null;
      var prev_sub_process_id = null;
      var prev_nextworkflow = [];
      var DupJobType = [];
      var DataWF = [];
      data.sort((a, b) => (a.wf_id > b.wf_id ? 1 : b.wf_id > a.wf_id ? -1 : 0));

      data.forEach((element) =>
        DupJobType.push({
          WF_ID: element.wf_id,
          CompanyID: element.company_id,
          ProjectID: element.project_id,
          JobTypeID: element.job_type_id,
          MainProcessID:
            element.main_process_id === null ? 1 : element.main_process_id,
          SubProcessID:
            (element.subprocessid === null) === null
              ? (subid = "-1")
              : (subid = element.subprocessid),
          ActionID: element.actionId,
          UserName: Cookies.get("username"),
        })
      );
      let uniqueObjArray = [
        ...new Map(
          DupJobType.map((item) => [item["WF_ID"] && item["JobTypeID"], item])
        ).values(),
      ];
      for (let i = 0; i < uniqueObjArray.length; i++) {
        const getBtn = await Api.post("getButtonDetailWeb", uniqueObjArray[i]);
        if (getBtn.data.result.value === "P") {
          const result = getBtn.data.return_nextWorkFlow.filter(
            (data_filter) =>
              data_filter.next_main_process_name === "Wait Re-Assign"
          );
          DataWF.push(result[0]);
        } else {
          DataWF = [];
        }
      }
      for (let i = 0; i < data.length; i++) {
        const resultWF = DataWF.filter(
          (data_wf) => data_wf.wf_id === data[i].wf_id
        );
        DataReassign.push({
          operator_id: Cookies.get("operator_id"),
          project_id: Cookies.get("project_id"),
          job_id: data[i].job_id,
          job_progress_id: data[i].job_progress_id,
          location_lat: data[i].location_lat,
          location_long: data[i].location_lon,
          progress_Status_flag: "",
          reject_service_ma_reason_id: "",
          reject_service_ma_remark: "",
          create_by: Cookies.get("username"),
          jobtypeid: data[i].job_type_id,
          ...resultWF[0],
        });
      }
      this.setState({
        data_reassign: DataReassign,
      });
    } else {
      this.setState({ visible_reassign: true });
      var subid =
        data.subprocessid === null
          ? (subid = "-1")
          : (subid = data.subprocessid);
      const getBtn = await Api.post("getButtonDetailWeb", {
        WF_ID: data.wf_id,
        CompanyID: data.company_id,
        ProjectID: data.project_id,
        JobTypeID: data.job_type_id,
        MainProcessID: data.main_process_id === null ? 1 : data.main_process_id,
        SubProcessID: subid,
        ActionID: data.actionid,
        UserName: Cookies.get("username"),
      });
      const result = getBtn.data.return_nextWorkFlow.filter(
        (data_filter) => data_filter.next_main_process_name === "Wait Re-Assign"
      );
      var dataset = {
        operator_id: Cookies.get("operator_id"),
        project_id: Cookies.get("project_id"),
        job_id: data.job_id,
        job_progress_id: data.job_progress_id,
        location_lat: data.location_lat,
        location_long: data.location_lon,
        progress_Status_flag: "",
        reject_service_ma_reason_id: "",
        reject_service_ma_remark: "",
        create_by: Cookies.get("username"),
        jobtypeid: data.job_type_id,
        ...result[0],
      };
      this.setState({
        data_reassign: dataset,
      });
    }
  };

  submitReasign = async () => {
    if (this.state.data_reassign.length > 1) {
      for (let i = 0; i < this.state.data_reassign.length; i++) {
        this.state.data_reassign[i]["reject_service_ma_remark"] =
          this.state.reject_service_ma_remark;
      }
      const submitReassign = await Api.post(
        "update_oper_job_reject_list",
        this.state.data_reassign
      );
      if (submitReassign.data.result.value === "P") {
        this.setState({ visible_reassign: false, modalstatus: true });
      }
    } else {
      this.state.data_reassign["reject_service_ma_remark"] =
        this.state.reject_service_ma_remark;
      const submitReassign = await Api.post("update_oper_job_reject_list", [
        this.state.data_reassign,
      ]);
      if (submitReassign.data.result.value === "P") {
        this.setState({ visible_reassign: false, modalstatus: true });
      }
    }
  };
  // for searching
  async SearchInput(value = "") {
    if (value === "") {
      this.setState({
        data_table_list: this.state.master_data,
      });
    } else {
      const tempFilteredData = this.state.master_data.filter((o) =>
        Object.keys(o).some((k) =>
          String(o[k]).toLowerCase().includes(value.toLowerCase())
        )
      );
      this.setState({
        data_table_list: tempFilteredData,
      });
    }
  }
  JobCategoryList = async (index, item, dataJobCat) => {
    await this.setState({
      loading: true,
      data: [],
    });

    var dataset = {
      company_id: Cookies.get("companyid"),
      operator_id: 0,
      project_id: 0,
      query_module: "oper",
      query_id: "2,3,4,5,6",
      param_text: `@company_id:$${Cookies.get(
        "companyid"
      )}##@operator_id:$${Cookies.get(
        "operator_id"
      )}##@project_id:$${Cookies.get(
        "project_id"
      )}##@select:$null##@job_status_id:$${!isEmpty(this.state.sc_type) ? this.state.sc_type.status : null
        }##@category_id:$${item.job_category_id
        }##@date:$null##@job_type:$null##@priority_id:$${!isEmpty(this.state.sc_type) ? this.state.sc_type.sc_Priority : null
        }##@create_by:$${Cookies.get(
          "userId"
        )}##@job_sub_type_id:$null##@sql_where:$'${this.state.qury_tab === ""
          ? "and job_status not in (999)"
          : this.state.qury_tab
        }'`,
      where_cond: "",
    };

    const getalljob = await Api.post("oper_get_query_group_list", dataset);
    const getWorkflow = await Api.post("GetBasicDataProcessWF", {
      company_id: 1,
      operator_id: 1,
      project_id: 1,
    });

    if (getalljob.data.result.code.toLowerCase() === "p") {
      for (var i = 0; i < getalljob.data.data.result_ma_job_list.length; i++) {
        getalljob.data.data.result_ma_job_list[i]["key"] = i;
      }
      let sum = 0;

      for (let i = 0; i < dataJobCat.length; i++) {
        const count_job_cat = getalljob.data.data.result_ma_job_list.filter(
          (data) => data.job_category_id === dataJobCat[i].job_category_id
        );
        // data.job_category_id === dataJobCat[i].job_category_id

        if (count_job_cat.length === 0) {
          dataJobCat[i]["job_category_count"] = 0;
        } else {
          dataJobCat[i]["job_category_count"] = count_job_cat.length;
        }
        sum +=
          dataJobCat[i].job_category_count != null
            ? dataJobCat[i].job_category_count
            : 0;
      }
      dataJobCat[0].job_category_count = sum;
      this.setState({
        data_table_list: getalljob.data.data.result_ma_job_list, // <------------------- slow because of this
        loading: false,
        job_category: dataJobCat,
        active_category: index,
        data_tab_category: item,
        data_export: getalljob.data.data,
        data: getalljob.data.data.result_ma_job_list,
        master_data: getalljob.data.data.result_ma_job_list,
        Urgent_total: getalljob.data.data.result_job_status[0].urgent,
        High_total: getalljob.data.data.result_count_priority[0].heigh,
        Normal_total: getalljob.data.data.result_count_priority[0].normal,
        Low_total: getalljob.data.data.result_count_priority[0].low,
        all_emp: getalljob.data.data.result_emp_team_list[0].all_emp,
        emp_working: getalljob.data.data.result_emp_team_list[0].emp_working,
        emp_ab: getalljob.data.data.result_emp_team_list[0].emp_ab,
        em_total: getalljob.data.data.result_emp_team_list[0].all_emp,
        em_available: getalljob.data.data.result_emp_team_list[0].emp_vacant,
        all_teamtotal: getalljob.data.data.result_emp_team_list[0].all_team,
        team_available_total:
          getalljob.data.data.result_emp_team_list[0].team_vacant,
        sum_alljob: getalljob.data.data.result_job_status[0].total_job,
        sum_onprocess: getalljob.data.data.result_job_status[0].on_process,
        sum_no_assing: getalljob.data.data.result_job_status[0].no_assign,
        factupdate: true,
        WorkFlow: getWorkflow.data.data
          ? getWorkflow.data.data.result_BasicDataProcessWF
          : [],
        sum_wait_assign: getalljob.data.data.result_job_status[0].reassign,
        sum_approve: getalljob.data.data.result_job_status[0].waitApprove,
        job_category_id: item.job_category_id,
      });
    } else {
      this.setState({
        loading: false,
      });
    }
  };
  onApprove = async () => {
    var subid = "";
    var WorkFlow_Loop = [];
    // var setJobId = "";
    var dataset = {};
    var set_jobID = "";
    var prev_wf_id = null;
    var prev_main_process_id = null;
    var prev_sub_process_id = null;
    var prev_nextworkflow = [];

    await this.setState({
      loading_checklist: true,
    });

    this.state.selectedRowlist.sort((a, b) =>
      a.wf_id > b.wf_id ? 1 : b.wf_id > a.wf_id ? -1 : 0
    );

    for (var i = 0; i < this.state.selectedRowlist.length; i++) {
      subid =
        this.state.selectedRowlist[i].subprocessid === null
          ? (subid = "-1")
          : (subid = this.state.selectedRowlist[i].subprocessid);
      if (
        this.state.selectedRowlist[i].wf_id != prev_wf_id &&
        this.state.selectedRowlist[i].main_process_id != prev_main_process_id &&
        subid != prev_sub_process_id
      ) {
        const getBtn = await Api.post("getButtonDetailWeb", {
          WF_ID: this.state.selectedRowlist[i].wf_id,
          CompanyID: this.state.selectedRowlist[i].company_id,
          ProjectID: this.state.selectedRowlist[i].project_id,
          JobTypeID: this.state.selectedRowlist[i].job_type_id,
          MainProcessID: this.state.selectedRowlist[i].main_process_id,
          SubProcessID: subid,
          ActionID: this.state.selectedRowlist[i].next_main_action_id,
          UserName: Cookies.get("username"),
        });

        var chekFlowM = getBtn.data.return_nextWorkFlow.filter(
          (element) =>
            element.next_flow === "M" &&
            element.next_main_process_name === "Complete"
        );
        //  dataset = ;
        WorkFlow_Loop.push({
          company_id: Cookies.get("companyid"),
          operator_id: Cookies.get("operator_id"),
          project_id: Cookies.get("project_id"),
          job_id: this.state.selectedRowlist[i].job_id,
          job_progress_id: this.state.selectedRowlist[i].job_progress_id,
          create_by: Cookies.get("username"),
          jobtypeid: this.state.selectedRowlist[i].jobtypeid,
          progress_Status_flag: "",
          checkFlag: 1,
          reject_reason_id: "",
          approve_remark: "",
          ...chekFlowM[0],
        });
        prev_wf_id = this.state.selectedRowlist[i].wf_id;
        prev_main_process_id = this.state.selectedRowlist[i].main_process_id;
        prev_sub_process_id = subid;
        prev_nextworkflow = chekFlowM;
      } else {
        WorkFlow_Loop.push({
          company_id: Cookies.get("companyid"),
          operator_id: Cookies.get("operator_id"),
          project_id: Cookies.get("project_id"),
          job_id: this.state.selectedRowlist[i].job_id,
          job_progress_id: this.state.selectedRowlist[i].job_progress_id,
          create_by: Cookies.get("username"),
          jobtypeid: this.state.selectedRowlist[i].jobtypeid,
          progress_Status_flag: "",
          checkFlag: 1,
          reject_reason_id: "",
          approve_remark: "",
          ...prev_nextworkflow[0],
        });
      }
      set_jobID += this.state.selectedRowlist[i].job_id + ",";
    }

    Cookies.set("job_id", set_jobID.substring(0, set_jobID.length - 1));
    this.setState({
      loading_checklist: false,
      dataapprove: WorkFlow_Loop,
      visible_modal_approve: true,
    });
  };
  checkVisibleModalGiveScore(isVisible) {
    this.setState({
      visible_modal_approve: isVisible,
    });
  }
  filterStatusApprove = (e) => {
    const result = this.state.master_data.filter((data) =>
      data.job_status_name.includes(e)
    );
    this.setState({
      data: result,
      value_status: e,
    });
  };
  setDataTabEMP = (index) => {
    this.setState({
      active_tab_skill: index,
      Checktab: index,
      active_emp_skill: 0,
    });
    setTimeout(() => this.onChangEmp(1, 0), 300);
  };
  CheckboxAssign = (value) => {
    if (value === "all") {
      if (this.state.checkboxAll === false) {
        for (let i = 0; i < this.state.data_table_list.length; i++) {
          this.state.data_table_list[i]["status_checkbox"] = true;
        }

        this.setState({
          data_table_list: this.state.data_table_list,
          selectedRowlist: this.state.data_table_list,
          checkboxAll: true,
        });
      } else {
        for (let i = 0; i < this.state.data_table_list.length; i++) {
          this.state.data_table_list[i]["status_checkbox"] = false;
        }
        this.setState({
          data_table_list: this.state.data_table_list,
          selectedRowlist: [],
          checkboxAll: false,
        });
      }
    } else {
      value["status_checkbox"] = !value["status_checkbox"];
      const setmaster = this.state.master_data.filter(
        (data) => data.job_id === value.job_id
      );
      setmaster["status_checkbox"] = !setmaster["status_checkbox"];
      const result = this.state.master_data.filter(
        (data) => data.status_checkbox === true
      );
      this.setState({
        data_table_list: this.state.data_table_list,
        selectedRowlist: result,
      });
    }
  };
  displayExxport = () => {
    this.setState({
      visible_export: true,
    });
  };
  exportToXLSX() {
    var result_array = [];
    var setHerder = {};
    const wb = XLSX.utils.book_new();
    for (const [key, value] of Object.entries(this.state.data_export)) {
      for (let i = 0; i < this.state.data_export[`${key}`].length; i++) {
        for (const [key_h, value_h] of Object.entries(
          this.state.data_export[`${key}`][i]
        )) {
          setHerder[`${key_h}`] = `${key_h}`;
        }
        result_array.push(this.state.data_export[`${key}`][i]);
      }
      let binaryWS = XLSX.utils.json_to_sheet([setHerder, ...result_array], {
        skipHeader: true,
      });
      XLSX.utils.book_append_sheet(wb, binaryWS, `${key}`);
      result_array = [];
      setHerder = {};
    }
    XLSX.writeFile(wb, this.state.file_name + ".xlsx");
  }
  listDataNewTab = async (data, type) => {
    this.setState({
      loading: true,
      statustab: 6,
      data_table_list: [],
      selectedRowlist: [],
      checkboxAll: false,
    });
    localStorage.setItem("default_tab_number", 6);
    var DataWorkFlow = [];
    DataWorkFlow = this.state.WorkFlow.filter(
      (element) =>
        element.process_desc === "No Assignment" ||
        element.process_desc === "Reject" ||
        element.process_desc === "Wait Re-Assign"
    );
    var qury = "and (job_status in ( ";
    for (let r = 0; r < DataWorkFlow.length; r++) {
      qury += DataWorkFlow[r].process_id + ",";
    }

    qury = qury.substring(qury, qury.length - 1) + ")";

    const getalljob = await Api.post("oper_get_query_group_list", {
      company_id: Cookies.get("companyid"),
      operator_id: 0,
      project_id: 0,
      query_module: "oper",
      query_id: "2,3,4,5,6",
      param_text: `@company_id:$${Cookies.get(
        "companyid"
      )}##@operator_id:$${Cookies.get(
        "operator_id"
      )}##@project_id:$${Cookies.get(
        "project_id"
      )}##@select:$null##@job_status_id:$${!isEmpty(this.state.sc_type) ? this.state.sc_type.status : null
        }##@category_id:$${this.state.job_category_id
        }##@date:$null##@job_type:$null##@priority_id:$${!isEmpty(this.state.sc_type) ? this.state.sc_type.sc_Priority : null
        }##@create_by:$${Cookies.get(
          "userId"
        )}##@job_sub_type_id:$null##@sql_where:$'${qury})'`,
      where_cond: "",
    });

    if (getalljob.data.result.code.toLowerCase() === "p") {
      this.setState({
        qury_tab: qury + ")",
      });
      if (hasFilteredValue !== "") {
        getalljob.data.data.result_ma_job_list =
          getalljob.data.data.result_ma_job_list.filter((item) =>
            filteredData.find((j) => j.job_id === item.job_id)
          );
      }
      for (
        var i = 0;
        i <
        (getalljob.data.data === null
          ? 0
          : getalljob.data.data.result_ma_job_list.length);
        i++
      ) {
        getalljob.data.data.result_ma_job_list[i]["key"] = i;
      }

      localStorage.setItem("default_tab", JSON.stringify(qury + ")"));

      for (let i = 0; i < getalljob.data.data.result_ma_job_list.length; i++) {
        getalljob.data.data.result_ma_job_list[i]["status_checkbox"] = false;
        getalljob.data.data.result_ma_job_list[i]["id"] = i;
      }
      let sum = 0;
      for (let i = 0; i < this.state.master_jobcategory.length; i++) {
        const count_job_cat = getalljob.data.data.result_count.filter(
          (data) =>
            data.job_category_id ===
            this.state.master_jobcategory[i].job_category_id
        );
        if (count_job_cat.length === 0) {
          this.state.master_jobcategory[i]["job_category_count"] = 0;
        } else {
          this.state.master_jobcategory[i]["job_category_count"] =
            count_job_cat[0]["counter"];
        }
        sum +=
          this.state.master_jobcategory[i].job_category_count != null
            ? this.state.master_jobcategory[i].job_category_count
            : 0;
      }
      this.state.master_jobcategory[0].job_category_count = sum;

      this.setState({
        data_table_list: getalljob.data.data.result_ma_job_list,
        loading: false,
        job_category: this.state.master_jobcategory,
        data_export: getalljob.data.data,
        data: getalljob.data.data.result_ma_job_list,
        master_data: getalljob.data.data.result_ma_job_list,
        Urgent_total: getalljob.data.data.result_count_priority[0].urgent,
        High_total: getalljob.data.data.result_count_priority[0].heigh,
        Normal_total: getalljob.data.data.result_count_priority[0].normal,
        Low_total: getalljob.data.data.result_count_priority[0].low,
        sum_wait_assign: getalljob.data.data.result_job_status[0].reassign,
        sum_approve: getalljob.data.data.result_job_status[0].waitApprove,
        sum_alljob: getalljob.data.data.result_job_status[0].total_job,
        sum_onprocess: getalljob.data.data.result_job_status[0].on_process,
        sum_no_assing: getalljob.data.data.result_job_status[0].no_assign,
      });
    } else {
      this.setState({
        loading: false,
      });
    }
  };

   setCookies(job_id, job_progress_id, job_type_id, maType, obj) {
    Cookies.set("maType", maType); 
    Cookies.set("job_id", job_id);
    Cookies.set("job_progress_id", job_progress_id);
    Cookies.set("job_type_id", job_type_id);
    localStorage.setItem("dataNext" ,JSON.stringify(this.state.data_table_list));
    localStorage.setItem("jobID_Back" , this.state.data_table_list[0]["job_id"]);
    localStorage.setItem("jobID_Last" , this.state.data_table_list[this.state.data_table_list.length - 1]["job_id"])
    setTimeout(function () {
      window.location.assign("/MaxiOperation/full_detail_job");
    }, 100);
  }
  render() {
    const {
      title,
      job_category,
      priority,
      selectedRowlist,
      active_category,
      data_tab_category,
    } = this.state;
    const rowSelectionList = {
      selectedRowlist,
      onChange: (selectedRowlist, selectedRows) => {
        this.setState({ selectedRowlist: selectedRows });
      },
      getCheckboxProps: (record) => ({
        disabled: record.name === "Disabled User",
        name: record.name,
      }),
    };
    return (
      <LayoutOperation title={title} active={1}>
        <Modal
          title="Export Excel File"
          centered
          visible={this.state.visible_export}
          footer={null}
          onCancel={() =>
            this.setState({
              visible_export: false,
            })
          }
          // width={200}
          className="custom-modal-map-large"
        >
          <div className="row" style={{ textAlign: "center", padding: "20px" }}>
            <div className="col-6">
              <span>ตั้งชื่อไฟล์ : </span>
            </div>
            <div className="col-6">
              <Input
                placeholder="ตั้งชื่อไฟล์"
                onChange={(e) =>
                  this.setState({
                    file_name: e.target.value,
                  })
                }
                style={{ width: "300px", marginLeft: "10px" }}
              />
            </div>
            <div className="col-12 mt-3" style={{ textAlign: "center" }}>
              <button
                onClick={() => this.exportToXLSX()}
                className="btn btn-secondary"
              >
                OK
              </button>
            </div>
          </div>
        </Modal>
        {this.state.visible_modal_approve ? (
          <ModalGiveStarScore
            handleVisible={this.checkVisibleModalGiveScore.bind(this)}
            dataapprove={this.state.dataapprove}
          />
        ) : null}
        <Spin spinning={this.state.loading_checklist}>
          {this.state.factupdate === true ? (
            <>
              {this.renderModalAssign()}
              {this.renderModalApproveSuccess()}
              {this.renderModalCancelAssign()}
              {this.renderModalReassign()}
              {this.state.modalstatus ? (
                <ModalSuccess
                  status="Successfully"
                  path_location="/MaxiOperation/ma_list"
                />
              ) : null}
              <div className="wrapper-header d-flex align-items-center">
                <div className="container-fluid">
                  <div className="row align-items-center">
                    <div className="col-2">
                      <img
                        src={Api.absoluteUrl("/icon/ma_list_white.svg")}
                        className="mr-3"
                      />
                      <h2 className="c-white text-uppercase m-0 d-inline-block font-mont-b font20">
                        {title}
                      </h2>
                    </div>
                    <div className="col-8">
                      <div className="row justify-content-center">
                        <div className="col-2">
                          <div className="d-flex justify-content-between align-items-center ">
                            <span className="font-thai-b c-white font16">
                              {this.state.factupdate === true ? (
                                <span>
                                  {
                                    this.state.data_translate[
                                    Cookies.get("locale")
                                    ]["status_high"]
                                  }
                                </span>
                              ) : null}{" "}
                            </span>
                            <div className="stat d-flex align-items-center orange">
                              <span className="font-thai-b font30 c-white w-100 text-center ">
                                {this.state.High_total}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="col-2">
                          <div className="d-flex justify-content-between align-items-center ">
                            <span className="font-thai-b c-white font14">
                              {" "}
                              {this.state.factupdate === true ? (
                                <span>
                                  {
                                    this.state.data_translate[
                                    Cookies.get("locale")
                                    ]["status_normal"]
                                  }
                                </span>
                              ) : null}{" "}
                            </span>
                            <div className="stat  d-flex align-items-center warning">
                              <span className="font-thai-b font30 c-white w-100 text-center ">
                                {this.state.Normal_total}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="col-2">
                          <div className="d-flex justify-content-between align-items-center ">
                            <span className="font-thai-b c-white font14">
                              {" "}
                              {this.state.factupdate === true ? (
                                <span>
                                  {
                                    this.state.data_translate[
                                    Cookies.get("locale")
                                    ]["status_low"]
                                  }
                                </span>
                              ) : null}{" "}
                            </span>
                            <div className="stat success d-flex align-items-center">
                              <span className="font-thai-b font30 c-white w-100 text-center ">
                                {this.state.Low_total}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-2 text-right">
                      <a
                        href="/MaxiOperation/"
                        className="c-white font-mont-m font12"
                      >
                        <img
                          src={Api.absoluteUrl("/icon/map.svg")}
                          className="mr-1"
                        />
                        Map
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="wrapper-body">
                <div className="container-fluid">
                  <div className="my-2 d-flex align-items-center justify-content-between">
                    <div>
                      <div className="d-flex">
                        <div className="mr-4">
                          <Input.Group compact>
                            <Select
                              placeholder="Status"
                              style={{ width: "140px" }}
                              onChange={this.onChangeasset}
                            >
                              {this.state.sc_status.map((item, index) => (
                                <Option
                                  value={item.status_id}
                                  key={index + 2525}
                                  type_sc="status"
                                >
                                  {item.status_desc}
                                </Option>
                              ))}
                            </Select>
                            <Select
                              placeholder="Priority"
                              style={{ width: "140px" }}
                              onChange={this.onChangeasset}
                            >
                              {priority.map((item, index) => (
                                <Option
                                  value={item.value}
                                  key={index + 6568}
                                  type_sc="sc_Priority"
                                >
                                  {item.text}
                                </Option>
                              ))}
                            </Select>
                          </Input.Group>
                        </div>
                        <div>
                          <Input.Group compact>
                            <RangePicker
                              onChange={this.onChangeasset}
                              style={{ marginLeft: "10px", color: "#000F9F" }}
                              name="date"
                            />
                            <Input.Search
                              placeholder="Please Insert"
                              onSearch={(value) => this.SearchInput(value)}
                              style={{ width: "300px", marginLeft: "10px" }}
                              enterButton
                            />
                            {/* <Select
                        placeholder="Select Search"
                        style={{ width: "140px" }}
                        onChange={this.onChangeasset}
                      >
                        {options.map((item, index) => (
                          <Option
                            value={item.value}
                            type_sc="sc_Insert"
                            type={item.type}
                          >
                            {item.text}
                          </Option>
                        ))}
                      </Select>
                      {this.state.checkType === "str" ? (
                        <Input.Search
                          placeholder="Please Insert"
                          onSearch={(value) => this.SearchInput(value)}
                          style={{ width: "300px", marginLeft: "10px" }}
                          enterButton
                        />
                      ) : null}
                      {this.state.checkType === "date" ? (
                        <RangePicker
                          onChange={this.onChangeasset}
                          style={{ marginLeft: "10px", color: "#000F9F" }}
                        />
                      ) : null} */}
                          </Input.Group>
                        </div>
                      </div>
                    </div>
                    <div>
                      <Link to="/addjob" className="btn btn-warning">
                        <img
                          src={Api.absoluteUrl("/icon/add_job.svg")}
                          width="14"
                          className="mr-2"
                        />
                        {this.state.factupdate === true ? (
                          <span>
                            {
                              this.state.data_translate[Cookies.get("locale")][
                              "add_job"
                              ]
                            }
                          </span>
                        ) : null}{" "}
                      </Link>
                      <button
                        className="btn btn-gray"
                        style={{
                          float: "right",
                          color: "white",
                          backgroundColor: "#888888",
                        }}
                        onClick={() => this.displayExxport()}
                      >
                        {/* <img
                        src={Api.absoluteUrl("/icon/plus.svg")}
                        width="14"
                        className="mr-2"
                      /> */}
                        Export
                      </button>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-2">
                      <div className="card-table-ma">
                        {this.state.factupdate === true ? (
                          <>
                            <h5
                              style={{
                                textAlign: "center",
                                paddingTop: "10px",
                                color: "#000F9F",
                              }}
                            >
                              Job Category
                            </h5>
                            <hr
                              style={{ marginLeft: "5%", marginRight: "5%" }}
                            />
                            <nav
                              className="nav flex-column"
                              style={{ position: "inherit" }}
                            >
                              {job_category.map((item, index) => {
                                return (
                                  <div className="row" key={index}>
                                    <div className="col-9">
                                      <a
                                        className="nav-link"
                                        href="#"
                                        style={
                                          active_category === index
                                            ? {
                                              borderLeft: "4px solid #0500A3",
                                              color: "#000F9F",
                                              fontWeight: "700",
                                            }
                                            : { color: "#6F6F6F" }
                                        }
                                        onClick={() =>
                                          this.JobCategoryList(
                                            index,
                                            item,
                                            this.state.job_category
                                          )
                                        }
                                        key={index + 570}
                                      >
                                        {item.job_category_name}
                                      </a>
                                    </div>
                                    <div className="col-1">
                                      <b
                                        className="mt-2"
                                        style={{
                                          display: "block",
                                          padding: "-0.5rem 1rem",
                                        }}
                                      >
                                        {item.job_category_count}
                                      </b>
                                    </div>
                                  </div>
                                );
                              })}
                            </nav>
                          </>
                        ) : null}
                      </div>
                    </div>
                    <div
                      className="col-10"
                    >
                      <Spin spinning={this.state.loading}>
                        <div className="card-table-ma">
                          <div
                            className="d-flex justify-content-between align-items-center"
                            style={{ paddingRight: "20px" }}
                          >
                            {/* backgroundColor: "#F4F5F7", */}
                            <ul className="nav">
                              <li
                                className="nav-item font10 font-mont-sb"
                                style={{ border: "1px solid #dadada" }}
                              >
                                <a
                                  href="#"
                                  onClick={() => this.tabjob(1, "ALL JOB")}
                                  className={
                                    this.state.statustab == 1
                                      ? "nav-link active"
                                      : "nav-link"
                                  }
                                >
                                  {this.state.factupdate === true ? (
                                    <span>
                                      {data_tab_category.job_category_name}
                                    </span>
                                  ) : null}{" "}

                                </a>
                              </li>
                              <li
                                className="nav-item font10 font-mont-sb"
                                style={{ border: "1px solid #dadada" }}
                              >
                                <a
                                  href="#"
                                  onClick={() => this.tabjob(2, "On process")}
                                  className={
                                    this.state.statustab == 2
                                      ? "nav-link active"
                                      : "nav-link"
                                  }
                                >
                                  {this.state.factupdate === true ? (
                                    <span>
                                      {
                                        this.state.data_translate[
                                        Cookies.get("locale")
                                        ]["status_onprocess"]
                                      }
                                    </span>
                                  ) : null}{" "}
                                  ({this.state.sum_onprocess})
                                </a>
                              </li>
                              <li
                                className="nav-item font10 font-mont-sb"
                                style={{ border: "1px solid #dadada" }}
                              >
                                <a
                                  href="#"
                                  onClick={() =>
                                    this.tabjob(3, "No Assignment")
                                  }
                                  className={
                                    this.state.statustab == 3
                                      ? "nav-link no-assign active"
                                      : "nav-link no-assign"
                                  }
                                >
                                  {this.state.factupdate === true ? (
                                    <span>
                                      {
                                        this.state.data_translate[
                                        Cookies.get("locale")
                                        ]["status_no_assignment"]
                                      }
                                    </span>
                                  ) : null}{" "}
                                  ({this.state.sum_no_assing})
                                </a>
                              </li>
                              <li
                                className="nav-item font10 font-mont-sb"
                                style={{ border: "1px solid #dadada" }}
                              >
                                <a
                                  href="#"
                                  onClick={() =>
                                    this.tabjob(4, "Wait Re-Assign")
                                  }
                                  className={
                                    this.state.statustab == 4
                                      ? "nav-link  active"
                                      : "nav-link"
                                  }
                                >
                                  {this.state.factupdate === true ? (
                                    <span>
                                      {
                                        this.state.data_translate[
                                        Cookies.get("locale")
                                        ]["status_wait_reassign"]
                                      }
                                    </span>
                                  ) : null}{" "}
                                  ({this.state.sum_wait_assign})
                                </a>
                              </li>
                              <li
                                className="nav-item font10 font-mont-sb"
                                style={{ border: "1px solid #dadada" }}
                              >
                                <a
                                  href="#"
                                  onClick={() => this.tabjob(5, "Wait Approve")}
                                  // className="nav-link no-assign"
                                  className={
                                    this.state.statustab == 5
                                      ? "nav-link  active"
                                      : "nav-link"
                                  }
                                >
                                  {this.state.factupdate === true ? (
                                    <span>{"Wait Approve"}</span>
                                  ) : null}{" "}
                                  ({this.state.sum_approve})
                                </a>
                              </li>
                              <li
                                className="nav-item font10 font-mont-sb "
                                style={{ border: "1px solid #dadada" }}
                              >
                                <a
                                  href="#"
                                  onClick={() => this.listDataNewTab()}
                                  className={
                                    this.state.statustab == 6
                                      ? "nav-link  active"
                                      : "nav-link"
                                  }
                                >
                                  <span>{"No Assign , Re-Assign"}</span>
                                  ({this.state.sum_no_assing + this.state.sum_wait_assign})
                                </a>
                              </li>
                            </ul>
                            {/* ==============================  All Job  ============================== */}
                          </div>
                          {this.state.statustab == 1 ? (
                            <div style={{ padding: "3px" }}>
                              <Table
                                size="small"
                                rowKey="job_id"
                                pagination={false}
                                columns={this.state.columns_allJob}
                                dataSource={this.state.data_table_list}
                                scroll={{ x: 500, y: 550 }}
                                style={{
                                  whiteSpace: "pre",
                                  lineHeight: "1 !important",
                                }}
                              />
                            </div>
                          ) : null}

                          {/* ==============================  On Process  ============================== */}
                          {this.state.statustab == 2 ? (
                            <div style={{ padding: "3px" }}>
                              <div className="row">
                                <div
                                  className="col-6"
                                  style={{ float: "left" }}
                                >
                                  {this.state.selectedRowlist.length > 1 ? (
                                    <>
                                      <a
                                        href="#"
                                        className="btn btn-warning"
                                        onClick={() =>
                                          this.onHandlereassign(
                                            this.state.selectedRowlist,
                                            "multireassign"
                                          )
                                        }
                                      >
                                        ReAssign
                                      </a>

                                      <a
                                        href="#"
                                        className="btn btn-warning"
                                        onClick={() => this.onModal(true, this.state.selectedRowlist, "Wait Ack Job Multi")}
                                      >
                                        Edit User
                                      </a>
                                    </>
                                  ) : null}
                                </div>
                              </div>
                              <Table
                                // className={css(tableCSS)}
                                size="small"
                                rowKey="job_id"
                                // loading={this.state.loading}
                                pagination={false}
                                columns={this.state.columns_on_process}
                                dataSource={this.state.data_table_list}
                                scroll={{ x: 500, y: 550 }}
                              />
                            </div>
                          ) : null}

                          {/* ==============================  No Assign   ============================== */}
                          {this.state.statustab == 3 || this.state.statustab == 4 || this.state.statustab == 6 ? (
                            <div style={{ padding: "3px" }}>
                              <div className="row">
                                <div className="col-12">
                                  {this.state.statustab === 3 ||
                                    this.state.statustab == 4 || this.state.statustab == 6 ? (
                                    <div className="row">
                                      <div
                                        className="col-6"
                                        style={{ float: "left" }}
                                      >
                                        {this.state.selectedRowlist.length >
                                          1 ? (
                                          <>
                                            <a
                                              href="#"
                                              className="btn btn-warning"
                                              onClick={() =>
                                                this.onModal(
                                                  true,
                                                  null,
                                                  "assignMulti"
                                                )
                                              }
                                            >
                                              Assign
                                            </a>
                                            <a
                                              href="#"
                                              className="btn btn-warning ml-2"
                                              onClick={() =>
                                                this.setState({
                                                  visible_cancel: true,
                                                  data_cancel:
                                                    this.state.selectedRowlist,
                                                })
                                              }
                                            >
                                              Cancel
                                            </a>
                                          </>
                                        ) : null}
                                      </div>
                                      <div className="col-6">
                                        <div
                                          className="row justify-content-center"
                                          style={{ float: "right" }}
                                        >
                                          <div className="col-auto text-center">
                                            <span className="font-thai-r font16 c-blue">
                                              All Employee
                                            </span>
                                            <h4
                                              className="font-thai-b font30"
                                              style={{ lineHeight: "24px" }}
                                            >
                                              {this.state.all_emp}
                                            </h4>
                                          </div>
                                          <div className="col-auto text-center">
                                            <span className="font-thai-r font16 c-blue">
                                              Employee Available
                                            </span>
                                            <h4
                                              className="font-thai-b font30 c-green"
                                              style={{ lineHeight: "24px" }}
                                            >
                                              {this.state.emp_working}
                                            </h4>
                                          </div>
                                          <div className="col-auto text-center">
                                            <span className="font-thai-r font16 c-blue">
                                              Employee Not Available
                                            </span>
                                            <h4
                                              className="font-thai-b font30 c-red"
                                              style={{ lineHeight: "24px" }}
                                            >
                                              {this.state.emp_ab}
                                            </h4>
                                          </div>
                                        </div>

                                        <div className="mt-4">
                                          <AssignJob />
                                        </div>
                                      </div>
                                    </div>
                                  ) : null}

                                  <hr className="m-0" />
                                  <Table
                                    pagination={false}
                                    rowKey="job_id"
                                    size="small"
                                    columns={this.state.columns_no_assign}
                                    dataSource={this.state.data_table_list}
                                    scroll={{ x: 500, y: 550 }}
                                    style={{
                                      whiteSpace: "nowrap",
                                      lineHeight: "0.7 !important",
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                          ) : null}

                          {/* =============================  Approve ============================= */}
                          {this.state.statustab == 5 ? (
                            <div style={{ padding: "3px" }}>
                              <div className="row">
                                <div className="col-12">
                                  {this.state.statustab === 5 ? (
                                    <div className="row">
                                      <div
                                        className="col-6  mb-1 mt-1"
                                        style={{
                                          float: "left",
                                          marginTop: "15px",
                                        }}
                                      >
                                        {this.state.selectedRowlist.length >
                                          1 ? (
                                          <a
                                            href="#"
                                            className="btn btn-warning"
                                            onClick={() => this.onApprove()}
                                          >
                                            Approve
                                          </a>
                                        ) : null}
                                      </div>
                                      <div
                                        className="col-6 mb-1 mt-1"
                                        style={{ textAlign: "right" }}
                                      >
                                        <Select
                                          placeholder="Status"
                                          style={{
                                            width: "50%",
                                            textAlign: "left",
                                          }}
                                          value={this.state.value_status}
                                          onChange={(e) =>
                                            this.filterStatusApprove(e)
                                          }
                                        >
                                          {this.state.status_wait_approve.map(
                                            (item, index) => (
                                              <Option
                                                value={item.value}
                                                key={index}
                                              >
                                                {item.text}
                                              </Option>
                                            )
                                          )}
                                        </Select>
                                      </div>
                                    </div>
                                  ) : null}
                                  <hr className="m-0" />
                                  <Table
                                    // pagination={false}
                                    rowKey="job_id"
                                    pagination={false}
                                    size="small"
                                    columns={this.state.columns_approve}
                                    dataSource={this.state.data}
                                    rowSelection={
                                      this.state.value_status ===
                                        "Wait TL Approve/Reject"
                                        ? rowSelectionList
                                        : null
                                    }
                                    // pagination={false}
                                    scroll={{ x: 500, y: 600 }}
                                    style={{
                                      whiteSpace: "nowrap",
                                      lineHeight: "1 !important",
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                          ) : null}
                        </div>
                      </Spin>
                    </div>
                  </div>
                </div>
              </div>
            </>
          ) : null}
        </Spin>
      </LayoutOperation>
    );
  }
}
const mapStateToProps = (state) => ({
  lang: state.lang,
});
const mapDispacthToProps = (dispatch) => {
  return {
    changeLang: (data) => dispatch(changeLang(data)),
  };
};

export default connect(mapStateToProps, mapDispacthToProps)(MaxiOperationMA);
